export interface TIso639Language {
  code: string;
  label: {
    "en-US": string;
    "de-DE": string;
    "pt-BR": string;
    "fr-FR": string;
    "zh-Hant-TW": string;
    "pt-PT": string;
    "ro-RO": string;
    "ja-JP": string;
    "zh-Hans-CN": string;
    "nl-NL": string;
    "es-ES": string;
    "sv-SE": string;
    "ru-RU": string;
    "hu-HU": string;
  };
}

export const iso639Languages = [
  {
    code: "aa",
    label: {
      "en-US": "Afar",
      "de-DE": "Afar",
      "pt-BR": "Afar",
      "fr-FR": "Afar",
      "zh-Hant-TW": "阿法爾語",
      "pt-PT": "Afar",
      "ro-RO": "Afar",
      "ja-JP": "アファール語",
      "zh-Hans-CN": "阿法尔语",
      "nl-NL": "Afar",
      "es-ES": "Afar",
      "sv-SE": "Afar",
      "ru-RU": "Афарский",
      "hu-HU": "Afar",
    },
  },
  {
    code: "ab",
    label: {
      "en-US": "Abkhazian",
      "de-DE": "Abchasisch",
      "pt-BR": "Abcásio",
      "fr-FR": "Abkhaze",
      "zh-Hant-TW": "阿布哈茲語",
      "pt-PT": "Abcásio",
      "ro-RO": "Abcásio",
      "ja-JP": "アブハズ語",
      "zh-Hans-CN": "阿布哈兹语",
      "nl-NL": "Abchazisch",
      "es-ES": "Abjazín",
      "sv-SE": "Abchaziska",
      "ru-RU": "Абхазский",
      "hu-HU": "Abkház",
    },
  },
  {
    code: "ae",
    label: {
      "en-US": "Avestan",
      "de-DE": "Avestisch",
      "pt-BR": "Avestano",
      "fr-FR": "Avestique",
      "zh-Hant-TW": "阿維斯陀語",
      "pt-PT": "Avestano",
      "ro-RO": "Avestan",
      "ja-JP": "アヴェスタン語",
      "zh-Hans-CN": "阿维斯陀语",
      "nl-NL": "Avestisch",
      "es-ES": "Avestano",
      "sv-SE": "Avestiska",
      "ru-RU": "Авестанский",
      "hu-HU": "Avestán",
    },
  },
  {
    code: "af",
    label: {
      "en-US": "Afrikaans",
      "de-DE": "Afrikaans",
      "pt-BR": "Afrikâner",
      "fr-FR": "Afrikaans",
      "zh-Hant-TW": "南非語",
      "pt-PT": "Afrikâner",
      "ro-RO": "Afrikaans",
      "ja-JP": "アフリカーンス語",
      "zh-Hans-CN": "阿非利堪斯语（南非荷兰语）",
      "nl-NL": "Afrikaans",
      "es-ES": "Afrikán",
      "sv-SE": "Afrikaans",
      "ru-RU": "Африкаанс",
      "hu-HU": "Afrikaans",
    },
  },
  {
    code: "ak",
    label: {
      "en-US": "Akan",
      "de-DE": "Akan",
      "pt-BR": "Akan",
      "fr-FR": "Akan",
      "zh-Hant-TW": "阿肯語",
      "pt-PT": "Akan",
      "ro-RO": "Akan",
      "ja-JP": "アカン語",
      "zh-Hans-CN": "阿坎语",
      "nl-NL": "Akan",
      "es-ES": "Akan",
      "sv-SE": "Akan",
      "ru-RU": "Акан",
      "hu-HU": "Akan",
    },
  },
  {
    code: "am",
    label: {
      "en-US": "Amharic",
      "de-DE": "Amharisch",
      "pt-BR": "Amárico",
      "fr-FR": "Amharique",
      "zh-Hant-TW": "阿姆哈拉語",
      "pt-PT": "Amárico",
      "ro-RO": "Amharic",
      "ja-JP": "アムハラ語",
      "zh-Hans-CN": "阿姆哈拉语",
      "nl-NL": "Amhaars",
      "es-ES": "Amárico",
      "sv-SE": "Amhariska",
      "ru-RU": "Амхарский",
      "hu-HU": "Amharic",
    },
  },
  {
    code: "an",
    label: {
      "en-US": "Aragonese",
      "de-DE": "Aragonesisch",
      "pt-BR": "Aragonês",
      "fr-FR": "Aragonês",
      "zh-Hant-TW": "阿拉貢語",
      "pt-PT": "Aragones",
      "ro-RO": "Aragoneză",
      "ja-JP": "アラゴニス語",
      "zh-Hans-CN": "阿拉贡语",
      "nl-NL": "Aragonees",
      "es-ES": "Aragonés",
      "sv-SE": "Aragoniska",
      "ru-RU": "Арагонский",
      "hu-HU": "Aragonés",
    },
  },
  {
    code: "ar",
    label: {
      "en-US": "Arabic",
      "de-DE": "Arabisch",
      "pt-BR": "Árabe",
      "fr-FR": "Arabe",
      "zh-Hant-TW": "阿拉伯語",
      "pt-PT": "Arábico",
      "ro-RO": "Arabic",
      "ja-JP": "アラビア語",
      "zh-Hans-CN": "阿拉伯语",
      "nl-NL": "Arabisch",
      "es-ES": "Árabe",
      "sv-SE": "Arabiska",
      "ru-RU": "Арабский",
      "hu-HU": "Arab",
    },
  },
  {
    code: "ar-SA",
    label: {
      "en-US": "Arabic (Saudi Arabia)",
      "de-DE": "Arabisch (Saudi-Arabien)",
      "pt-BR": "Árabe (Arábia Saudita)",
      "fr-FR": "Arabe (Arabie saoudite)",
      "zh-Hant-TW": "阿拉伯語（沙烏地阿拉伯）",
      "pt-PT": "Árabe (Arábia Saudita)",
      "ro-RO": "Arabă (Arabia Saudită)",
      "ja-JP": "アラビア語（サウジアラビア）",
      "zh-Hans-CN": "阿拉伯语（沙特阿拉伯）",
      "nl-NL": "Arabisch (Saoedi-Arabië)",
      "es-ES": "Árabe (Arabia Saudita)",
      "sv-SE": "Arabiska (Saudiarabien)",
      "ru-RU": "Арабский (Саудовская Аравия)",
      "hu-HU": "Arab (Szaudiarabia)",
    },
  },
  {
    code: "ar-EG",
    label: {
      "en-US": "Arabic (Egypt)",
      "de-DE": "Arabisch (Ägypten)",
      "pt-BR": "Árabe (Egito)",
      "fr-FR": "Arabe (Égypte)",
      "zh-Hant-TW": "阿拉伯語（埃及）",
      "pt-PT": "Árabe (Egito)",
      "ro-RO": "Arabă (Egipt)",
      "ja-JP": "アラビア語（エジプト）",
      "zh-Hans-CN": "阿拉伯语（埃及）",
      "nl-NL": "Arabisch (Egypte)",
      "es-ES": "Árabe (Egipto)",
      "sv-SE": "Arabiska (Egypten)",
      "ru-RU": "Арабский (Египет)",
      "hu-HU": "Arab (Egyiptom)",
    },
  },
  {
    code: "ar-AE",
    label: {
      "en-US": "Arabic (United Arab Emirates)",
      "de-DE": "Arabisch (Vereinigte Arabische Emirate)",
      "pt-BR": "Árabe (Emirados Árabes Unidos)",
      "fr-FR": "Arabe (Émirats arabes unis)",
      "zh-Hant-TW": "阿拉伯語（阿拉伯聯合大公國）",
      "pt-PT": "Árabe (Emirados Árabes Unidos)",
      "ro-RO": "Arabă (Emiratele Arabe Unite)",
      "ja-JP": "アラビア語（アラブ首長国連邦）",
      "zh-Hans-CN": "阿拉伯语（阿拉伯联合酋长国）",
      "nl-NL": "Arabisch (Verenigde Arabische Emiraten)",
      "es-ES": "Árabe (Emiratos Árabes Unidos)",
      "sv-SE": "Arabiska (Förenade Arabemiraten)",
      "ru-RU": "Арабский (ОАЭ)",
      "hu-HU": "Arab (Egyesült Arab Emirátusok)",
    },
  },
  {
    code: "ar-MA",
    label: {
      "en-US": "Arabic (Morocco)",
      "de-DE": "Arabisch (Marokko)",
      "pt-BR": "Árabe (Marrocos)",
      "fr-FR": "Arabe (Maroc)",
      "zh-Hant-TW": "阿拉伯語（摩洛哥）",
      "pt-PT": "Árabe (Marrocos)",
      "ro-RO": "Arabă (Maroc)",
      "ja-JP": "アラビア語（モロッコ）",
      "zh-Hans-CN": "阿拉伯语（摩洛哥）",
      "nl-NL": "Arabisch (Marokko)",
      "es-ES": "Árabe (Marruecos)",
      "sv-SE": "Arabiska (Marocko)",
      "ru-RU": "Арабский (Марокко)",
      "hu-HU": "Arab (Marokkó)",
    },
  },
  {
    code: "as",
    label: {
      "en-US": "Assamese",
      "de-DE": "Assamesisch",
      "pt-BR": "Assamês",
      "fr-FR": "Assamais",
      "zh-Hant-TW": "阿薩姆語",
      "pt-PT": "Assamese",
      "ro-RO": "Assamese",
      "ja-JP": "アッサム語",
      "zh-Hans-CN": "阿萨姆语",
      "nl-NL": "Assamees",
      "es-ES": "Asamés",
      "sv-SE": "Assamesiska",
      "ru-RU": "Ассамский",
      "hu-HU": "Asszámi",
    },
  },
  {
    code: "av",
    label: {
      "en-US": "Avaric",
      "de-DE": "Avarisch",
      "pt-BR": "Avaric",
      "fr-FR": "Avaric",
      "zh-Hant-TW": "阿瓦爾語",
      "pt-PT": "Avaric",
      "ro-RO": "Avaric",
      "ja-JP": "アヴァリック語",
      "zh-Hans-CN": "阿瓦尔语",
      "nl-NL": "Avarisch",
      "es-ES": "Avaro",
      "sv-SE": "Avariska",
      "ru-RU": "Аварский",
      "hu-HU": "Avar",
    },
  },
  {
    code: "ay",
    label: {
      "en-US": "Aymara",
      "de-DE": "Aymara",
      "pt-BR": "Aymara",
      "fr-FR": "Aymara",
      "zh-Hant-TW": "艾馬拉語",
      "pt-PT": "Aymara",
      "ro-RO": "Aymara",
      "ja-JP": "アイマラ語",
      "zh-Hans-CN": "艾马拉语",
      "nl-NL": "Aymara",
      "es-ES": "Aimara",
      "sv-SE": "Aymara",
      "ru-RU": "Аймара",
      "hu-HU": "Aymara",
    },
  },
  {
    code: "az",
    label: {
      "en-US": "Azerbaijani",
      "de-DE": "Aserbaidschanisch",
      "pt-BR": "Azerbaijano",
      "fr-FR": "Azerbaïdjanais",
      "zh-Hant-TW": "亞塞拜然語",
      "pt-PT": "Azerbaijano",
      "ro-RO": "Azerbaijani",
      "ja-JP": "アゼルバイジャン語",
      "zh-Hans-CN": "阿塞拜疆语",
      "nl-NL": "Azerbeidzjaans",
      "es-ES": "Azerbaiyano",
      "sv-SE": "Azerbaidjanska",
      "ru-RU": "Азербайджанский",
      "hu-HU": "Azerbaijani",
    },
  },
  {
    code: "ba",
    label: {
      "en-US": "Bashkir",
      "de-DE": "Baschkirisch",
      "pt-BR": "Basco",
      "fr-FR": "Bashkir",
      "zh-Hant-TW": "巴什基爾語",
      "pt-PT": "Basco",
      "ro-RO": "Bashkir",
      "ja-JP": "バシキール語",
      "zh-Hans-CN": "巴什基尔语",
      "nl-NL": "Basjkiers",
      "es-ES": "Bashkír",
      "sv-SE": "Basjkiriska",
      "ru-RU": "Башкирский",
      "hu-HU": "Baskír",
    },
  },
  {
    code: "be",
    label: {
      "en-US": "Belarusian",
      "de-DE": "Weißrussisch",
      "pt-BR": "Bielorrusso",
      "fr-FR": "Biélorusse",
      "zh-Hant-TW": "白俄羅斯語",
      "pt-PT": "Bielorrusso",
      "ro-RO": "Belarusian",
      "ja-JP": "ベラルーシ語",
      "zh-Hans-CN": "白俄罗斯语",
      "nl-NL": "Wit-Russisch",
      "es-ES": "Bielorruso",
      "sv-SE": "Belarusiska",
      "ru-RU": "Белорусский",
      "hu-HU": "Belarusian",
    },
  },
  {
    code: "bg",
    label: {
      "en-US": "Bulgarian",
      "de-DE": "Bulgarisch",
      "pt-BR": "Búlgaro",
      "fr-FR": "Bulgare",
      "zh-Hant-TW": "保加利亞語",
      "pt-PT": "Búlgaro",
      "ro-RO": "Bulgarian",
      "ja-JP": "ブルガリア語",
      "zh-Hans-CN": "保加利亚语",
      "nl-NL": "Bulgaars",
      "es-ES": "Búlgaro",
      "sv-SE": "Bulgariska",
      "ru-RU": "Болгарский",
      "hu-HU": "Bulgarian",
    },
  },
  {
    code: "bh",
    label: {
      "en-US": "Bihari languages",
      "de-DE": "Biharische Sprachen",
      "pt-BR": "Bihari",
      "fr-FR": "Bihari",
      "zh-Hant-TW": "比哈里語",
      "pt-PT": "Bihari",
      "ro-RO": "Bihari languages",
      "ja-JP": "ビハリ語",
      "zh-Hans-CN": "比哈里语",
      "nl-NL": "Bihari-talen",
      "es-ES": "Bihari",
      "sv-SE": "Bihari-språk",
      "ru-RU": "Бихарский",
      "hu-HU": "Bihari",
    },
  },
  {
    code: "bi",
    label: {
      "en-US": "Bislama",
      "de-DE": "Bislama",
      "pt-BR": "Bislama",
      "fr-FR": "Bislama",
      "zh-Hant-TW": "比斯拉馬語",
      "pt-PT": "Bislama",
      "ro-RO": "Bislama",
      "ja-JP": "ビスラマ語",
      "zh-Hans-CN": "比斯拉马语",
      "nl-NL": "Bislama",
      "es-ES": "Bislama",
      "sv-SE": "Bislama",
      "ru-RU": "Бислама",
      "hu-HU": "Bislama",
    },
  },
  {
    code: "bm",
    label: {
      "en-US": "Bambara",
      "de-DE": "Bambara",
      "pt-BR": "Bambara",
      "fr-FR": "Bambara",
      "zh-Hant-TW": "班巴拉語",
      "pt-PT": "Bambara",
      "ro-RO": "Bambara",
      "ja-JP": "バンバラ語",
      "zh-Hans-CN": "班巴拉语",
      "nl-NL": "Bambara",
      "es-ES": "Bambara",
      "sv-SE": "Bambara",
      "ru-RU": "Банту",
      "hu-HU": "Bambara",
    },
  },
  {
    code: "bn",
    label: {
      "en-US": "Bengali",
      "de-DE": "Bengali",
      "pt-BR": "Bengali",
      "fr-FR": "Bengali",
      "zh-Hant-TW": "孟加拉語",
      "pt-PT": "Bengali",
      "ro-RO": "Bengali",
      "ja-JP": "ベンガル語",
      "zh-Hans-CN": "孟加拉语",
      "nl-NL": "Bengalees",
      "es-ES": "Bengalí",
      "sv-SE": "Bengali",
      "ru-RU": "Бенгальский",
      "hu-HU": "Bengali",
    },
  },
  {
    code: "bo",
    label: {
      "en-US": "Tibetan",
      "de-DE": "Tibetisch",
      "pt-BR": "Tibetano",
      "fr-FR": "Tibétain",
      "zh-Hant-TW": "藏語",
      "pt-PT": "Tibetano",
      "ro-RO": "Tibetan",
      "ja-JP": "チベット語",
      "zh-Hans-CN": "藏语",
      "nl-NL": "Tibetaans",
      "es-ES": "Tibetano",
      "sv-SE": "Tibetiska",
      "ru-RU": "Тибетский",
      "hu-HU": "Tibetan",
    },
  },
  {
    code: "br",
    label: {
      "en-US": "Breton",
      "de-DE": "Bretonisch",
      "pt-BR": "Breton",
      "fr-FR": "Breton",
      "zh-Hant-TW": "布列塔尼語",
      "pt-PT": "Breton",
      "ro-RO": "Breton",
      "ja-JP": "ブレトン語",
      "zh-Hans-CN": "布列塔尼语",
      "nl-NL": "Bretons",
      "es-ES": "Bretón",
      "sv-SE": "Bretonska",
      "ru-RU": "Бретонский",
      "hu-HU": "Breton",
    },
  },
  {
    code: "bs",
    label: {
      "en-US": "Bosnian",
      "de-DE": "Bosnisch",
      "pt-BR": "Bósnio",
      "fr-FR": "Bosnien",
      "zh-Hant-TW": "波士尼亞語",
      "pt-PT": "Bosnian",
      "ro-RO": "Bosnian",
      "ja-JP": "ボスニア語",
      "zh-Hans-CN": "波斯尼亚语",
      "nl-NL": "Bosnisch",
      "es-ES": "Bosnio",
      "sv-SE": "Bosniska",
      "ru-RU": "Боснийский",
      "hu-HU": "Bosnian",
    },
  },
  {
    code: "ca",
    label: {
      "en-US": "Catalan; Valencian",
      "de-DE": "Katalanisch; Valencisch",
      "pt-BR": "Catalão; Valenciano",
      "fr-FR": "Catalan; Valencian",
      "zh-Hant-TW": "加泰隆尼亞語；瓦倫西亞語",
      "pt-PT": "Catalão; Valenciano",
      "ro-RO": "Catalan; Valencian",
      "ja-JP": "カタロニア語；バレンシア語",
      "zh-Hans-CN": "加泰罗尼亚语；瓦伦西亚语",
      "nl-NL": "Catalaans; Valenciaans",
      "es-ES": "Catalán; Valenciano",
      "sv-SE": "Katalanska; Valencianska",
      "ru-RU": "Каталонский; Валенсийский",
      "hu-HU": "Catalan; Valencian",
    },
  },
  {
    code: "ce",
    label: {
      "en-US": "Chechen",
      "de-DE": "Tschetschenisch",
      "pt-BR": "Checheno",
      "fr-FR": "Tchechen",
      "zh-Hant-TW": "車臣語",
      "pt-PT": "Tchechen",
      "ro-RO": "Tchechen",
      "ja-JP": "チェチェン語",
      "zh-Hans-CN": "车臣语",
      "nl-NL": "Tsjetsjeens",
      "es-ES": "Tchecheno",
      "sv-SE": "Tjetjensk",
      "ru-RU": "Чеченский",
      "hu-HU": "Chechen",
    },
  },
  {
    code: "ch",
    label: {
      "en-US": "Chamorro",
      "de-DE": "Chamorro",
      "pt-BR": "Chamorro",
      "fr-FR": "Chamorro",
      "zh-Hant-TW": "查莫羅語",
      "pt-PT": "Chamorro",
      "ro-RO": "Chamorro",
      "ja-JP": "チャモロ語",
      "zh-Hans-CN": "查莫罗语",
      "nl-NL": "Chamorro",
      "es-ES": "Chamorro",
      "sv-SE": "Chamorro",
      "ru-RU": "Чаморро",
      "hu-HU": "Chamorro",
    },
  },
  {
    code: "co",
    label: {
      "en-US": "Corsican",
      "de-DE": "Korsisch",
      "pt-BR": "Corsican",
      "fr-FR": "Corsican",
      "zh-Hant-TW": "科西嘉語",
      "pt-PT": "Corsican",
      "ro-RO": "Corsican",
      "ja-JP": "コルシカ語",
      "zh-Hans-CN": "科西嘉语",
      "nl-NL": "Corsicaans",
      "es-ES": "Corsican",
      "sv-SE": "Korsiska",
      "ru-RU": "Корсиканский",
      "hu-HU": "Corsican",
    },
  },
  {
    code: "cr",
    label: {
      "en-US": "Cree",
      "de-DE": "Cree",
      "pt-BR": "Cree",
      "fr-FR": "Cree",
      "zh-Hant-TW": "克里語",
      "pt-PT": "Cree",
      "ro-RO": "Cree",
      "ja-JP": "クリー語",
      "zh-Hans-CN": "克里语",
      "nl-NL": "Cree",
      "es-ES": "Cree",
      "sv-SE": "Cree",
      "ru-RU": "Крейский",
      "hu-HU": "Cree",
    },
  },
  {
    code: "cs",
    label: {
      "en-US": "Czech",
      "de-DE": "Tschechisch",
      "pt-BR": "Tcheco",
      "fr-FR": "Tcheque",
      "zh-Hant-TW": "捷克語",
      "pt-PT": "Tcheco",
      "ro-RO": "Tcheco",
      "ja-JP": "チェコ語",
      "zh-Hans-CN": "捷克语",
      "nl-NL": "Tsjechisch",
      "es-ES": "Tcheco",
      "sv-SE": "Tjeckiska",
      "ru-RU": "Чешский",
      "hu-HU": "Czech",
    },
  },
  {
    code: "cu",
    label: {
      "en-US": "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic",
      "de-DE": "Kirchenslawisch; Altbulgarisch; Kirchenslawisch; Altbulgarisch; Altkirchliches Slawisch",
      "pt-BR":
        "Slavônico eclesiástico; Antigo eslavônico; Sânscrito eclesiástico; Antigo búlgaro; Antigo sânscrito eclesiástico",
      "fr-FR":
        "Slavon épiscopal; Ancien slave; Sanscrit épiscopal; Ancien bulgare; Ancien sanscrit épiscopal",
      "zh-Hant-TW": "教會斯拉夫語；古教會斯拉夫語；古保加利亞語",
      "pt-PT":
        "Sânscrito eclesiástico; Antigo eslavônico; Sânscrito eclesiástico; Antigo búlgaro; Antigo sânscrito eclesiástico",
      "ro-RO":
        "Sânscrito eclesiástico; Antigo eslavônico; Sânscrito eclesiástico; Antigo búlgaro; Antigo sânscrito eclesiástico",
      "ja-JP": "キリル文字の古教会斯拉夫語；古教会斯拉夫語；古教会斯拉夫語；古保加利亞語；古教会斯拉夫語",
      "zh-Hans-CN": "教会斯拉夫语；古教会斯拉夫语；古保加利亚语",
      "nl-NL": "Kerkslavisch; Oudslavisch; Oudbulgaars",
      "es-ES":
        "Slavônico eclesiástico; Antigo eslavônico; Sânscrito eclesiástico; Antigo búlgaro; Antigo sânscrito eclesiástico",
      "sv-SE":
        "Kyrilliskt gamla kyrkoslaviska; Kyrilliskt gamla kyrkoslaviska; Kyrilliskt gamla kyrkoslaviska; Kyrilliskt gamla bulgariska; Kyrilliskt gamla kyrkoslaviska",
      "ru-RU": "Славянский; Старый славянский; Старый болгарский; Старый教会斯拉夫ский",
      "hu-HU": "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic",
    },
  },
  {
    code: "cv",
    label: {
      "en-US": "Chuvash",
      "de-DE": "Tschuwaschisch",
      "pt-BR": "Tchuvasco",
      "fr-FR": "Tchuvasche",
      "zh-Hant-TW": "楚瓦什語",
      "pt-PT": "Tchuvasche",
      "ro-RO": "Tchuvasche",
      "ja-JP": "チュバシャ語",
      "zh-Hans-CN": "楚瓦什语",
      "nl-NL": "Tsjoevasjisch",
      "es-ES": "Tchuvasche",
      "sv-SE": "Tjuvasjiska",
      "ru-RU": "Чувашский",
      "hu-HU": "Chuvash",
    },
  },
  {
    code: "cy",
    label: {
      "en-US": "Welsh",
      "de-DE": "Walisisch",
      "pt-BR": "Galês",
      "fr-FR": "Gallois",
      "zh-Hant-TW": "威爾斯語",
      "pt-PT": "Galês",
      "ro-RO": "Galês",
      "ja-JP": "ウェールズ語",
      "zh-Hans-CN": "威尔士语",
      "nl-NL": "Welsh",
      "es-ES": "Galês",
      "sv-SE": "Walisiska",
      "ru-RU": "Валлийский",
      "hu-HU": "Welsh",
    },
  },
  {
    code: "da",
    label: {
      "en-US": "Danish",
      "de-DE": "Dänisch",
      "pt-BR": "Dinamarquês",
      "fr-FR": "Danois",
      "zh-Hant-TW": "丹麥語",
      "pt-PT": "Dinamarquês",
      "ro-RO": "Danish",
      "ja-JP": "デンマーク語",
      "zh-Hans-CN": "丹麦语",
      "nl-NL": "Deens",
      "es-ES": "Dinamarquês",
      "sv-SE": "Danska",
      "ru-RU": "Датский",
      "hu-HU": "Danish",
    },
  },
  {
    code: "de",
    label: {
      "en-US": "German",
      "de-DE": "Deutsch",
      "pt-BR": "Alemão",
      "fr-FR": "Allemand",
      "zh-Hant-TW": "德語",
      "pt-PT": "Alemão",
      "ro-RO": "German",
      "ja-JP": "ドイツ語",
      "zh-Hans-CN": "德语",
      "nl-NL": "Duits",
      "es-ES": "Alemão",
      "sv-SE": "Tyska",
      "ru-RU": "Немецкий",
      "hu-HU": "German",
    },
  },
  {
    code: "de-DE",
    label: {
      "en-US": "German (Germany)",
      "de-DE": "Deutsch (Deutschland)",
      "pt-BR": "Alemão (Alemanha)",
      "fr-FR": "Allemand (Allemagne)",
      "zh-Hant-TW": "德語（德國）",
      "pt-PT": "Alemão (Alemanha)",
      "ro-RO": "Germană (Germania)",
      "ja-JP": "ドイツ語（ドイツ）",
      "zh-Hans-CN": "德语（德国）",
      "nl-NL": "Duits (Duitsland)",
      "es-ES": "Alemán (Alemania)",
      "sv-SE": "Tyska (Tyskland)",
      "ru-RU": "Немецкий (Германия)",
      "hu-HU": "German (Germany)",
    },
  },
  {
    code: "de-AT",
    label: {
      "en-US": "German (Austria)",
      "de-DE": "Deutsch (Österreich)",
      "pt-BR": "Alemão (Áustria)",
      "fr-FR": "Allemand (Autriche)",
      "zh-Hant-TW": "德語（奧地利）",
      "pt-PT": "Alemão (Áustria)",
      "ro-RO": "Germană (Austria)",
      "ja-JP": "ドイツ語（オーストリア）",
      "zh-Hans-CN": "德语（奥地利）",
      "nl-NL": "Duits (Oostenrijk)",
      "es-ES": "Alemán (Austria)",
      "sv-SE": "Tyska (Österrike)",
      "ru-RU": "Немецкий (Австрия)",
      "hu-HU": "German (Austria)",
    },
  },
  {
    code: "de-CH",
    label: {
      "en-US": "German (Switzerland)",
      "de-DE": "Deutsch (Schweiz)",
      "pt-BR": "Alemão (Suíça)",
      "fr-FR": "Allemand (Suisse)",
      "zh-Hant-TW": "德語（瑞士）",
      "pt-PT": "Alemão (Suíça)",
      "ro-RO": "Germană (Elveția)",
      "ja-JP": "ドイツ語（スイス）",
      "zh-Hans-CN": "德语（瑞士）",
      "nl-NL": "Duits (Zwitserland)",
      "es-ES": "Alemán (Suiza)",
      "sv-SE": "Tyska (Schweiz)",
      "ru-RU": "Немецкий (Швейцария)",
      "hu-HU": "German (Switzerland)",
    },
  },
  {
    code: "dv",
    label: {
      "en-US": "Divehi; Dhivehi; Maldivian",
      "de-DE": "Divehi; Dhivehi; Maldivisch",
      "pt-BR": "Divehi; Dhivehi; Maldiviano",
      "fr-FR": "Divehi; Dhivehi; Maldivien",
      "zh-Hant-TW": "迪維西語；迪維西語；馬爾地夫語",
      "pt-PT": "Divehi; Dhivehi; Maldiviano",
      "ro-RO": "Divehi; Dhivehi; Maldiviano",
      "ja-JP": "ディベヒ語；ディベヒ語；マルディブ語",
      "zh-Hans-CN": "迪维希语；马尔代夫语",
      "nl-NL": "Divehi; Dhivehi; Maldivisch",
      "es-ES": "Divehi; Dhivehi; Maldiviano",
      "sv-SE": "Divehi; Dhivehi; Maldiviska",
      "ru-RU": "Дивехи; Дхивехи; Мальдивский",
      "hu-HU": "Divehi; Dhivehi; Maldivian",
    },
  },
  {
    code: "dz",
    label: {
      "en-US": "Dzongkha",
      "de-DE": "Dzongkha",
      "pt-BR": "Dzongkha",
      "fr-FR": "Dzongkha",
      "zh-Hant-TW": "宗喀語",
      "pt-PT": "Dzongkha",
      "ro-RO": "Dzongkha",
      "ja-JP": "ゾング語",
      "zh-Hans-CN": "宗喀语",
      "nl-NL": "Dzongkha",
      "es-ES": "Dzongkha",
      "sv-SE": "Dzongkha",
      "ru-RU": "Дзонг-ке",
      "hu-HU": "Dzongkha",
    },
  },
  {
    code: "ee",
    label: {
      "en-US": "Ewe",
      "de-DE": "Ewe",
      "pt-BR": "Ewe",
      "fr-FR": "Ewe",
      "zh-Hant-TW": "埃維語",
      "pt-PT": "Ewe",
      "ro-RO": "Ewe",
      "ja-JP": "エヴェ語",
      "zh-Hans-CN": "埃维语",
      "nl-NL": "Ewe",
      "es-ES": "Ewe",
      "sv-SE": "Ewe",
      "ru-RU": "Еве",
      "hu-HU": "Ewe",
    },
  },
  {
    code: "el",
    label: {
      "en-US": "Greek, Modern (1453-)",
      "de-DE": "Griechisch, Modern (ab 1453)",
      "pt-BR": "Grego moderno (1453-)",
      "fr-FR": "Grec moderne (après 1453)",
      "zh-Hant-TW": "希臘語（現代，1453-）",
      "pt-PT": "Grego moderno (1453-)",
      "ro-RO": "Grec modern (după 1453)",
      "ja-JP": "ギリシャ語（現代，1453-）",
      "zh-Hans-CN": "希腊语（现代，1453-）",
      "nl-NL": "Grieks, Modern (na 1453)",
      "es-ES": "Griego moderno (1453-)",
      "sv-SE": "Grekisk, modern (efter 1453)",
      "ru-RU": "Греческий; Современный (после 1453)",
      "hu-HU": "Greek, Modern (1453-)",
    },
  },
  {
    code: "en",
    label: {
      "en-US": "English",
      "de-DE": "Englisch",
      "pt-BR": "Inglês",
      "fr-FR": "Anglais",
      "zh-Hant-TW": "英文",
      "pt-PT": "Inglês",
      "ro-RO": "Engleză",
      "ja-JP": "英語",
      "zh-Hans-CN": "英语",
      "nl-NL": "Engels",
      "es-ES": "Inglés",
      "sv-SE": "Engelska",
      "ru-RU": "Английский",
      "hu-HU": "English",
    },
  },
  {
    code: "en-US",
    label: {
      "en-US": "English (United States)",
      "de-DE": "Englisch (Vereinigte Staaten)",
      "pt-BR": "Inglês (Estados Unidos)",
      "fr-FR": "Anglais (États-Unis)",
      "zh-Hant-TW": "英文（美國）",
      "pt-PT": "Inglês (Estados Unidos)",
      "ro-RO": "Engleză (Statele Unite)",
      "ja-JP": "英語（アメリカ）",
      "zh-Hans-CN": "英语（美国）",
      "nl-NL": "Engels (Verenigde Staten)",
      "es-ES": "Inglés (Estados Unidos)",
      "sv-SE": "Engelska (USA)",
      "ru-RU": "Английский (США)",
      "hu-HU": "English (United States)",
    },
  },
  {
    code: "en-GB",
    label: {
      "en-US": "English (United Kingdom)",
      "de-DE": "Englisch (Vereinigtes Königreich)",
      "pt-BR": "Inglês (Reino Unido)",
      "fr-FR": "Anglais (Royaume-Uni)",
      "zh-Hant-TW": "英文（英國）",
      "pt-PT": "Inglês (Reino Unido)",
      "ro-RO": "Engleză (Regatul Unit)",
      "ja-JP": "英語（イギリス）",
      "zh-Hans-CN": "英语（英国）",
      "nl-NL": "Engels (Verenigd Koninkrijk)",
      "es-ES": "Inglés (Reino Unido)",
      "sv-SE": "Engelska (Storbritannien)",
      "ru-RU": "Английский (Великобритания)",
      "hu-HU": "English (United Kingdom)",
    },
  },
  {
    code: "en-AU",
    label: {
      "en-US": "English (Australia)",
      "de-DE": "Englisch (Australien)",
      "pt-BR": "Inglês (Austrália)",
      "fr-FR": "Anglais (Australie)",
      "zh-Hant-TW": "英文（澳洲）",
      "pt-PT": "Inglês (Austrália)",
      "ro-RO": "Engleză (Australia)",
      "ja-JP": "英語（オーストラリア）",
      "zh-Hans-CN": "英语（澳大利亚）",
      "nl-NL": "Engels (Australië)",
      "es-ES": "Inglés (Australia)",
      "sv-SE": "Engelska (Australien)",
      "ru-RU": "Английский (Австралия)",
      "hu-HU": "English (Australia)",
    },
  },
  {
    code: "en-CA",
    label: {
      "en-US": "English (Canada)",
      "de-DE": "Englisch (Kanada)",
      "pt-BR": "Inglês (Canadá)",
      "fr-FR": "Anglais (Canada)",
      "zh-Hant-TW": "英文（加拿大）",
      "pt-PT": "Inglês (Canadá)",
      "ro-RO": "Engleză (Canada)",
      "ja-JP": "英語（カナダ）",
      "zh-Hans-CN": "英语（加拿大）",
      "nl-NL": "Engels (Canada)",
      "es-ES": "Inglés (Canadá)",
      "sv-SE": "Engelska (Kanada)",
      "ru-RU": "Английский (Канада)",
      "hu-HU": "English (Canada)",
    },
  },
  {
    code: "en-IE",
    label: {
      "en-US": "English (Ireland)",
      "de-DE": "Englisch (Irland)",
      "pt-BR": "Inglês (Irlanda)",
      "fr-FR": "Anglais (Irlande)",
      "zh-Hant-TW": "英文（愛爾蘭）",
      "pt-PT": "Inglês (Irlanda)",
      "ro-RO": "Engleză (Irlanda)",
      "ja-JP": "英語（アイルランド）",
      "zh-Hans-CN": "英语（爱尔兰）",
      "nl-NL": "Engels (Ierland)",
      "es-ES": "Inglés (Irlanda)",
      "sv-SE": "Engelska (Irland)",
      "ru-RU": "Английский (Ирландия)",
      "hu-HU": "English (Ireland)",
    },
  },
  {
    code: "eo",
    label: {
      "en-US": "Esperanto",
      "de-DE": "Esperanto",
      "pt-BR": "Esperanto",
      "fr-FR": "Esperanto",
      "zh-Hant-TW": "世界語",
      "pt-PT": "Esperanto",
      "ro-RO": "Esperanto",
      "ja-JP": "エスペラント語",
      "zh-Hans-CN": "世界语",
      "nl-NL": "Esperanto",
      "es-ES": "Esperanto",
      "sv-SE": "Esperanto",
      "ru-RU": "Эсперанто",
      "hu-HU": "Esperanto",
    },
  },
  {
    code: "es",
    label: {
      "en-US": "Spanish; Castilian",
      "de-DE": "Spanisch; Kastilisch",
      "pt-BR": "Espanhol; Castelao",
      "fr-FR": "Espagnol; Castillan",
      "zh-Hant-TW": "西班牙語；卡斯提爾語",
      "pt-PT": "Espanhol; Castelao",
      "ro-RO": "Spaniol; Castilian",
      "ja-JP": "スペイン語；カスティーリャ語",
      "zh-Hans-CN": "西班牙语；卡斯蒂利亚语",
      "nl-NL": "Spaans; Castiliaans",
      "es-ES": "Español; Castiliano",
      "sv-SE": "Spanska; Kastilianska",
      "ru-RU": "Испанский; Кастильский",
      "hu-HU": "Spanish; Castilian",
    },
  },
  {
    code: "es-ES",
    label: {
      "en-US": "Spanish (Spain)",
      "de-DE": "Spanisch (Spanien)",
      "pt-BR": "Espanhol (Espanha)",
      "fr-FR": "Espagnol (Espagne)",
      "zh-Hant-TW": "西班牙語（西班牙）",
      "pt-PT": "Espanhol (Espanha)",
      "ro-RO": "Spaniolă (Spania)",
      "ja-JP": "スペイン語（スペイン）",
      "zh-Hans-CN": "西班牙语（西班牙）",
      "nl-NL": "Spaans (Spanje)",
      "es-ES": "Español (España)",
      "sv-SE": "Spanska (Spanien)",
      "ru-RU": "Испанский (Испания)",
      "hu-HU": "Spanish (Spain)",
    },
  },
  {
    code: "es-MX",
    label: {
      "en-US": "Spanish (Mexico)",
      "de-DE": "Spanisch (Mexiko)",
      "pt-BR": "Espanhol (México)",
      "fr-FR": "Espagnol (Mexique)",
      "zh-Hant-TW": "西班牙語（墨西哥）",
      "pt-PT": "Espanhol (México)",
      "ro-RO": "Spaniolă (Mexic)",
      "ja-JP": "スペイン語（メキシコ）",
      "zh-Hans-CN": "西班牙语（墨西哥）",
      "nl-NL": "Spaans (Mexico)",
      "es-ES": "Español (México)",
      "sv-SE": "Spanska (Mexiko)",
      "ru-RU": "Испанский (Мексика)",
      "hu-HU": "Spanish (Mexico)",
    },
  },
  {
    code: "es-AR",
    label: {
      "en-US": "Spanish (Argentina)",
      "de-DE": "Spanisch (Argentinien)",
      "pt-BR": "Espanhol (Argentina)",
      "fr-FR": "Espagnol (Argentine)",
      "zh-Hant-TW": "西班牙語（阿根廷）",
      "pt-PT": "Espanhol (Argentina)",
      "ro-RO": "Spaniolă (Argentina)",
      "ja-JP": "スペイン語（アルゼンチン）",
      "zh-Hans-CN": "西班牙语（阿根廷）",
      "nl-NL": "Spaans (Argentinië)",
      "es-ES": "Español (Argentina)",
      "sv-SE": "Spanska (Argentina)",
      "ru-RU": "Испанский (Аргентина)",
      "hu-HU": "Spanish (Argentina)",
    },
  },
  {
    code: "es-CO",
    label: {
      "en-US": "Spanish (Colombia)",
      "de-DE": "Spanisch (Kolumbien)",
      "pt-BR": "Espanhol (Colômbia)",
      "fr-FR": "Espagnol (Colombie)",
      "zh-Hant-TW": "西班牙語（哥倫比亞）",
      "pt-PT": "Espanhol (Colômbia)",
      "ro-RO": "Spaniolă (Columbia)",
      "ja-JP": "スペイン語（コロンビア）",
      "zh-Hans-CN": "西班牙语（哥伦比亚）",
      "nl-NL": "Spaans (Colombia)",
      "es-ES": "Español (Colombia)",
      "sv-SE": "Spanska (Colombia)",
      "ru-RU": "Испанский (Колумбия)",
      "hu-HU": "Spanish (Colombia)",
    },
  },
  {
    code: "es-CL",
    label: {
      "en-US": "Spanish (Chile)",
      "de-DE": "Spanisch (Chile)",
      "pt-BR": "Espanhol (Chile)",
      "fr-FR": "Espagnol (Chili)",
      "zh-Hant-TW": "西班牙語（智利）",
      "pt-PT": "Espanhol (Chile)",
      "ro-RO": "Spaniolă (Chile)",
      "ja-JP": "スペイン語（チリ）",
      "zh-Hans-CN": "西班牙语（智利）",
      "nl-NL": "Spaans (Chili)",
      "es-ES": "Español (Chile)",
      "sv-SE": "Spanska (Chile)",
      "ru-RU": "Испанский (Чили)",
      "hu-HU": "Spanish (Chile)",
    },
  },
  {
    code: "es-PE",
    label: {
      "en-US": "Spanish (Peru)",
      "de-DE": "Spanisch (Peru)",
      "pt-BR": "Espanhol (Peru)",
      "fr-FR": "Espagnol (Pérou)",
      "zh-Hant-TW": "西班牙語（秘魯）",
      "pt-PT": "Espanhol (Peru)",
      "ro-RO": "Spaniolă (Peru)",
      "ja-JP": "スペイン語（ペルー）",
      "zh-Hans-CN": "西班牙语（秘鲁）",
      "nl-NL": "Spaans (Peru)",
      "es-ES": "Español (Perú)",
      "sv-SE": "Spanska (Peru)",
      "ru-RU": "Испанский (Перу)",
      "hu-HU": "Spanish (Peru)",
    },
  },
  {
    code: "es-VE",
    label: {
      "en-US": "Spanish (Venezuela)",
      "de-DE": "Spanisch (Venezuela)",
      "pt-BR": "Espanhol (Venezuela)",
      "fr-FR": "Espagnol (Venezuela)",
      "zh-Hant-TW": "西班牙語（委內瑞拉）",
      "pt-PT": "Espanhol (Venezuela)",
      "ro-RO": "Spaniolă (Venezuela)",
      "ja-JP": "スペイン語（ベネズエラ）",
      "zh-Hans-CN": "西班牙语（委内瑞拉）",
      "nl-NL": "Spaans (Venezuela)",
      "es-ES": "Español (Venezuela)",
      "sv-SE": "Spanska (Venezuela)",
      "ru-RU": "Испанский (Венесуэла)",
      "hu-HU": "Spanish (Venezuela)",
    },
  },
  {
    code: "et",
    label: {
      "en-US": "Estonian",
      "de-DE": "Estnisch",
      "pt-BR": "Estoniano",
      "fr-FR": "Estonien",
      "zh-Hant-TW": "愛沙尼亞語",
      "pt-PT": "Estoniano",
      "ro-RO": "Estonian",
      "ja-JP": "エストニア語",
      "zh-Hans-CN": "爱沙尼亚语",
      "nl-NL": "Estisch",
      "es-ES": "Estonio",
      "sv-SE": "Estniska",
      "ru-RU": "Эстонский",
      "hu-HU": "Estonian",
    },
  },
  {
    code: "eu",
    label: {
      "en-US": "Basque",
      "de-DE": "Baskisch",
      "pt-BR": "Basco",
      "fr-FR": "Basque",
      "zh-Hant-TW": "巴斯克語",
      "pt-PT": "Basco",
      "ro-RO": "Basque",
      "ja-JP": "バスク語",
      "zh-Hans-CN": "巴斯克语",
      "nl-NL": "Baskisch",
      "es-ES": "Vasco",
      "sv-SE": "Baskiska",
      "ru-RU": "Баскский",
      "hu-HU": "Basque",
    },
  },
  {
    code: "fa",
    label: {
      "en-US": "Persian",
      "de-DE": "Persisch",
      "pt-BR": "Persa",
      "fr-FR": "Persan",
      "zh-Hant-TW": "波斯語",
      "pt-PT": "Persa",
      "ro-RO": "Persian",
      "ja-JP": "ペルシア語",
      "zh-Hans-CN": "波斯语",
      "nl-NL": "Perzisch",
      "es-ES": "Persa",
      "sv-SE": "Persiska",
      "ru-RU": "Персидский",
      "hu-HU": "Persian",
    },
  },
  {
    code: "ff",
    label: {
      "en-US": "Fulah",
      "de-DE": "Fulah",
      "pt-BR": "Fulah",
      "fr-FR": "Fulah",
      "zh-Hant-TW": "富拉語",
      "pt-PT": "Fulah",
      "ro-RO": "Fulah",
      "ja-JP": "フラ語",
      "zh-Hans-CN": "富拉语",
      "nl-NL": "Fulah",
      "es-ES": "Fulah",
      "sv-SE": "Fulah",
      "ru-RU": "Фула",
      "hu-HU": "Fulah",
    },
  },
  {
    code: "fi",
    label: {
      "en-US": "Finnish",
      "de-DE": "Finnisch",
      "pt-BR": "Finlandês",
      "fr-FR": "Finlandais",
      "zh-Hant-TW": "芬蘭語",
      "pt-PT": "Finlandês",
      "ro-RO": "Finlandeză",
      "ja-JP": "フィンランド語",
      "zh-Hans-CN": "芬兰语",
      "nl-NL": "Fins",
      "es-ES": "Finés",
      "sv-SE": "Finska",
      "ru-RU": "Финский",
      "hu-HU": "Finnish",
    },
  },
  {
    code: "fj",
    label: {
      "en-US": "Fijian",
      "de-DE": "Fidschianisch",
      "pt-BR": "Fijiano",
      "fr-FR": "Fijien",
      "zh-Hant-TW": "斐濟語",
      "pt-PT": "Fijiano",
      "ro-RO": "Fijian",
      "ja-JP": "フィジー語",
      "zh-Hans-CN": "斐济语",
      "nl-NL": "Fijiaans",
      "es-ES": "Fijiano",
      "sv-SE": "Fidsjianska",
      "ru-RU": "Фиджийский",
      "hu-HU": "Fijian",
    },
  },
  {
    code: "fo",
    label: {
      "en-US": "Faroese",
      "de-DE": "Färöisch",
      "pt-BR": "Feroês",
      "fr-FR": "Féroïen",
      "zh-Hant-TW": "法羅語",
      "pt-PT": "Feroês",
      "ro-RO": "Feroe",
      "ja-JP": "フェロー語",
      "zh-Hans-CN": "法罗语",
      "nl-NL": "Faeröers",
      "es-ES": "Feroés",
      "sv-SE": "Färöiska",
      "ru-RU": "Фарерский",
      "hu-HU": "Faroese",
    },
  },
  {
    code: "fr",
    label: {
      "en-US": "French",
      "de-DE": "Französisch",
      "pt-BR": "Francês",
      "fr-FR": "Français",
      "zh-Hant-TW": "法語",
      "pt-PT": "Francês",
      "ro-RO": "Franceză",
      "ja-JP": "フランス語",
      "zh-Hans-CN": "法语",
      "nl-NL": "Frans",
      "es-ES": "Francés",
      "sv-SE": "Franska",
      "ru-RU": "Французский",
      "hu-HU": "French",
    },
  },
  {
    code: "fr-FR",
    label: {
      "en-US": "French (France)",
      "de-DE": "Französisch (Frankreich)",
      "pt-BR": "Francês (França)",
      "fr-FR": "Français (France)",
      "zh-Hant-TW": "法語（法國）",
      "pt-PT": "Francês (França)",
      "ro-RO": "Franceză (Franța)",
      "ja-JP": "フランス語（フランス）",
      "zh-Hans-CN": "法语（法国）",
      "nl-NL": "Frans (Frankrijk)",
      "es-ES": "Francés (Francia)",
      "sv-SE": "Franska (Frankrike)",
      "ru-RU": "Французский (Франция)",
      "hu-HU": "French (France)",
    },
  },
  {
    code: "fr-CA",
    label: {
      "en-US": "French (Canada)",
      "de-DE": "Französisch (Kanada)",
      "pt-BR": "Francês (Canadá)",
      "fr-FR": "Français (Canada)",
      "zh-Hant-TW": "法語（加拿大）",
      "pt-PT": "Francês (Canadá)",
      "ro-RO": "Franceză (Canada)",
      "ja-JP": "フランス語（カナダ）",
      "zh-Hans-CN": "法语（加拿大）",
      "nl-NL": "Frans (Canada)",
      "es-ES": "Francés (Canadá)",
      "sv-SE": "Franska (Kanada)",
      "ru-RU": "Французский (Канада)",
      "hu-HU": "French (Canada)",
    },
  },
  {
    code: "fr-BE",
    label: {
      "en-US": "French (Belgium)",
      "de-DE": "Französisch (Belgien)",
      "pt-BR": "Francês (Bélgica)",
      "fr-FR": "Français (Belgique)",
      "zh-Hant-TW": "法語（比利時）",
      "pt-PT": "Francês (Bélgica)",
      "ro-RO": "Franceză (Belgia)",
      "ja-JP": "フランス語（ベルギー）",
      "zh-Hans-CN": "法语（比利时）",
      "nl-NL": "Frans (België)",
      "es-ES": "Francés (Bélgica)",
      "sv-SE": "Franska (Belgien)",
      "ru-RU": "Французский (Бельгия)",
      "hu-HU": "French (Belgium)",
    },
  },
  {
    code: "fr-CH",
    label: {
      "en-US": "French (Switzerland)",
      "de-DE": "Französisch (Schweiz)",
      "pt-BR": "Francês (Suíça)",
      "fr-FR": "Français (Suisse)",
      "zh-Hant-TW": "法語（瑞士）",
      "pt-PT": "Francês (Suíça)",
      "ro-RO": "Franceză (Elveția)",
      "ja-JP": "フランス語（スイス）",
      "zh-Hans-CN": "法语（瑞士）",
      "nl-NL": "Frans (Zwitserland)",
      "es-ES": "Francés (Suiza)",
      "sv-SE": "Franska (Schweiz)",
      "ru-RU": "Французский (Швейцария)",
      "hu-HU": "French (Switzerland)",
    },
  },
  {
    code: "fy",
    label: {
      "en-US": "Western Frisian",
      "de-DE": "Westfriesisch",
      "pt-BR": "Frísio ocidental",
      "fr-FR": "Frison occidental",
      "zh-Hant-TW": "西弗里斯蘭語",
      "pt-PT": "Frísio ocidental",
      "ro-RO": "Frisian",
      "ja-JP": "西フリジア語",
      "zh-Hans-CN": "西弗里斯兰语",
      "nl-NL": "West-Fries",
      "es-ES": "Frisio occidental",
      "sv-SE": "Västfriesiska",
      "ru-RU": "Западнофризский",
      "hu-HU": "Western Frisian",
    },
  },
  {
    code: "ga",
    label: {
      "en-US": "Irish",
      "de-DE": "Irischer",
      "pt-BR": "Irlandês",
      "fr-FR": "Irlandais",
      "zh-Hant-TW": "愛爾蘭語",
      "pt-PT": "Irlandês",
      "ro-RO": "Irlandeză",
      "ja-JP": "アイルランド語",
      "zh-Hans-CN": "爱尔兰语",
      "nl-NL": "Iers",
      "es-ES": "Irlandés",
      "sv-SE": "Irisiska",
      "ru-RU": "Ирландский",
      "hu-HU": "Irish",
    },
  },
  {
    code: "gd",
    label: {
      "en-US": "Gaelic; Scottish Gaelic",
      "de-DE": "Gälisch; Schottisch Gälisch",
      "pt-BR": "Gaelico escocês; Gaélico escocês",
      "fr-FR": "Gaélique écossais; Gaélique écossais",
      "zh-Hant-TW": "蓋爾語；蘇格蘭蓋爾語",
      "pt-PT": "Gaélico escocês; Gaélico escocês",
      "ro-RO": "Gaélic; Gaélic scoțian",
      "ja-JP": "ゲール語；スコットランド語",
      "zh-Hans-CN": "盖尔语；苏格兰盖尔语",
      "nl-NL": "Gaelisch; Schots-Gaelisch",
      "es-ES": "Gaélico escocés; Gaélico escocés",
      "sv-SE": "Skotsk gäliska; Skotsk gäliska",
      "ru-RU": "Шотландский; Шотландский гэльский",
      "hu-HU": "Gaelic; Scottish Gaelic",
    },
  },
  {
    code: "gl",
    label: {
      "en-US": "Galician",
      "de-DE": "Galicisch",
      "pt-BR": "Galego",
      "fr-FR": "Galicien",
      "zh-Hant-TW": "加利西亞語",
      "pt-PT": "Galego",
      "ro-RO": "Galician",
      "ja-JP": "ガリシア語",
      "zh-Hans-CN": "加利西亚语",
      "nl-NL": "Galicisch",
      "es-ES": "Galego",
      "sv-SE": "Galicisch",
      "ru-RU": "Галисийский",
      "hu-HU": "Galician",
    },
  },
  {
    code: "gn",
    label: {
      "en-US": "Guarani",
      "de-DE": "Guarani",
      "pt-BR": "Guarani",
      "fr-FR": "Guarani",
      "zh-Hant-TW": "瓜拉尼語",
      "pt-PT": "Guarani",
      "ro-RO": "Guaraní",
      "ja-JP": "ガラナ語",
      "zh-Hans-CN": "瓜拉尼语",
      "nl-NL": "Guaraní",
      "es-ES": "Guaraní",
      "sv-SE": "Guaraní",
      "ru-RU": "Гуарани",
      "hu-HU": "Guarani",
    },
  },
  {
    code: "gu",
    label: {
      "en-US": "Gujarati",
      "de-DE": "Gujarati",
      "pt-BR": "Gujarati",
      "fr-FR": "Gujarati",
      "zh-Hant-TW": "古吉拉特語",
      "pt-PT": "Gujarati",
      "ro-RO": "Gujarati",
      "ja-JP": "グジャラート語",
      "zh-Hans-CN": "古吉拉特语",
      "nl-NL": "Gujarati",
      "es-ES": "Gujarati",
      "sv-SE": "Gujarati",
      "ru-RU": "Гуджарати",
      "hu-HU": "Gujarati",
    },
  },
  {
    code: "gv",
    label: {
      "en-US": "Manx",
      "de-DE": "Manx",
      "pt-BR": "Manx",
      "fr-FR": "Manx",
      "zh-Hant-TW": "曼島語",
      "pt-PT": "Manx",
      "ro-RO": "Manx",
      "ja-JP": "マンク語",
      "zh-Hans-CN": "曼岛语",
      "nl-NL": "Manx",
      "es-ES": "Manx",
      "sv-SE": "Manx",
      "ru-RU": "Манксский",
      "hu-HU": "Manx",
    },
  },
  {
    code: "ha",
    label: {
      "en-US": "Hausa",
      "de-DE": "Hausa",
      "pt-BR": "Hausa",
      "fr-FR": "Hausa",
      "zh-Hant-TW": "豪薩語",
      "pt-PT": "Hausa",
      "ro-RO": "Hausa",
      "ja-JP": "ハウサ語",
      "zh-Hans-CN": "豪萨语",
      "nl-NL": "Hausa",
      "es-ES": "Hausa",
      "sv-SE": "Hausa",
      "ru-RU": "Хауса",
      "hu-HU": "Hausa",
    },
  },
  {
    code: "he",
    label: {
      "en-US": "Hebrew",
      "de-DE": "Hebräisch",
      "pt-BR": "Hebraico",
      "fr-FR": "Hébreu",
      "zh-Hant-TW": "希伯來語",
      "pt-PT": "Hebraico",
      "ro-RO": "Ebraică",
      "ja-JP": "ヘブライ語",
      "zh-Hans-CN": "希伯来语",
      "nl-NL": "Hebreeuws",
      "es-ES": "Hebreo",
      "sv-SE": "Hebreiska",
      "ru-RU": "Иврит",
      "hu-HU": "Hebrew",
    },
  },
  {
    code: "hi",
    label: {
      "en-US": "Hindi",
      "de-DE": "Hindi",
      "pt-BR": "Hindi",
      "fr-FR": "Hindi",
      "zh-Hant-TW": "印地語",
      "pt-PT": "Hindi",
      "ro-RO": "Hindi",
      "ja-JP": "ヒンディー語",
      "zh-Hans-CN": "印地语",
      "nl-NL": "Hindi",
      "es-ES": "Hindi",
      "sv-SE": "Hindi",
      "ru-RU": "Хинди",
      "hu-HU": "Hindi",
    },
  },
  {
    code: "ho",
    label: {
      "en-US": "Hiri Motu",
      "de-DE": "Hiri Motu",
      "pt-BR": "Hiri Motu",
      "fr-FR": "Hiri Motu",
      "zh-Hant-TW": "希里莫圖語",
      "pt-PT": "Hiri Motu",
      "ro-RO": "Hiri Motu",
      "ja-JP": "ヒリモト語",
      "zh-Hans-CN": "希里莫图语",
      "nl-NL": "Hiri Motu",
      "es-ES": "Hiri Motu",
      "sv-SE": "Hiri Motu",
      "ru-RU": "Хири Моту",
      "hu-HU": "Hiri Motu",
    },
  },
  {
    code: "hr",
    label: {
      "en-US": "Croatian",
      "de-DE": "Kroatisch",
      "pt-BR": "Croata",
      "fr-FR": "Croate",
      "zh-Hant-TW": "克羅埃西亞語",
      "pt-PT": "Croata",
      "ro-RO": "Croată",
      "ja-JP": "クロアチア語",
      "zh-Hans-CN": "克罗地亚语",
      "nl-NL": "Croatisch",
      "es-ES": "Croata",
      "sv-SE": "Kroatiska",
      "ru-RU": "Хорватский",
      "hu-HU": "Croatian",
    },
  },
  {
    code: "ht",
    label: {
      "en-US": "Haitian; Haitian Creole",
      "de-DE": "Haitian; Haitian Creole",
      "pt-BR": "Haitiano; Crioulo haitiano",
      "fr-FR": "Haïtien; Créole haïtien",
      "zh-Hant-TW": "海地語；海地克里奧爾語",
      "pt-PT": "Haitiano; Crioulo haitiano",
      "ro-RO": "Haitian; Haitian Creole",
      "ja-JP": "ハイチ語；ハイチクリオール語",
      "zh-Hans-CN": "海地语；海地克里奥尔语",
      "nl-NL": "Haitiaans; Creools haïtiaans",
      "es-ES": "Haitiano; Crioulo haitiano",
      "sv-SE": "Haitianskt kreol; Haitianskt kreol",
      "ru-RU": "Гаитянский; Гаитянский креольский",
      "hu-HU": "Haitian; Haitian Creole",
    },
  },
  {
    code: "hu",
    label: {
      "en-US": "Hungarian",
      "de-DE": "Ungarisch",
      "pt-BR": "Húngaro",
      "fr-FR": "Hongrois",
      "zh-Hant-TW": "匈牙利語",
      "pt-PT": "Húngaro",
      "ro-RO": "Maghiară",
      "ja-JP": "ハンガリー語",
      "zh-Hans-CN": "匈牙利语",
      "nl-NL": "Hongaars",
      "es-ES": "Húngaro",
      "sv-SE": "Ungerska",
      "ru-RU": "Венгерский",
      "hu-HU": "Hungarian",
    },
  },
  {
    code: "hy",
    label: {
      "en-US": "Armenian",
      "de-DE": "Armenisch",
      "pt-BR": "Armênio",
      "fr-FR": "Arménien",
      "zh-Hant-TW": "亞美尼亞語",
      "pt-PT": "Armênio",
      "ro-RO": "Armenian",
      "ja-JP": "アルメニア語",
      "zh-Hans-CN": "亚美尼亚语",
      "nl-NL": "Armeens",
      "es-ES": "Arménio",
      "sv-SE": "Armeniska",
      "ru-RU": "Армянский",
      "hu-HU": "Armenian",
    },
  },
  {
    code: "hz",
    label: {
      "en-US": "Herero",
      "de-DE": "Herero",
      "pt-BR": "Herero",
      "fr-FR": "Herero",
      "zh-Hant-TW": "赫雷羅語",
      "pt-PT": "Herero",
      "ro-RO": "Herero",
      "ja-JP": "ヒェロ語",
      "zh-Hans-CN": "赫雷罗语",
      "nl-NL": "Herero",
      "es-ES": "Herero",
      "sv-SE": "Herero",
      "ru-RU": "Хереро",
      "hu-HU": "Herero",
    },
  },
  {
    code: "ia",
    label: {
      "en-US": "Interlingua (International Auxiliary Language Association)",
      "de-DE": "Interlingua (Internationaler Hilfssprachverband)",
      "pt-BR": "Interlingua (Associação Internacional de Línguas Auxiliares)",
      "fr-FR": "Interlingua (Association internationale des langues auxiliaires)",
      "zh-Hant-TW": "國際語（國際輔助語言協會）",
      "pt-PT": "Interlingua (Associação Internacional de Línguas Auxiliares)",
      "ro-RO": "Interlingua (International Auxiliary Language Association)",
      "ja-JP": "国際語（国際輔助語言協会）",
      "zh-Hans-CN": "国际语（国际辅助语言协会）",
      "nl-NL": "Interlingua (Association internationale des langues auxiliaires)",
      "es-ES": "Interlingua (Association internationale des langues auxiliares)",
      "sv-SE": "Interlingua (Association internationale des langues auxiliares)",
      "ru-RU": "Международный вспомогательный язык (Международная ассоциация вспомогательных языков)",
      "hu-HU": "Interlingua (International Auxiliary Language Association)",
    },
  },
  {
    code: "id",
    label: {
      "en-US": "Indonesian",
      "de-DE": "Indonesisch",
      "pt-BR": "Indonésio",
      "fr-FR": "Indonésien",
      "zh-Hant-TW": "印尼語",
      "pt-PT": "Indonésio",
      "ro-RO": "Indonesian",
      "ja-JP": "インドネシア語",
      "zh-Hans-CN": "印尼语",
      "nl-NL": "Indonesisch",
      "es-ES": "Indonésio",
      "sv-SE": "Indonesiska",
      "ru-RU": "Индонезийский",
      "hu-HU": "Indonesian",
    },
  },
  {
    code: "ie",
    label: {
      "en-US": "Interlingue; Occidental",
      "de-DE": "Interlingue; Occidental",
      "pt-BR": "Interlingue; Ocidental",
      "fr-FR": "Interlingue; Ocidental",
      "zh-Hant-TW": "國際語；西方語",
      "pt-PT": "Interlingue; Ocidental",
      "ro-RO": "Interlingue; Occidental",
      "ja-JP": "国際語；西方語",
      "zh-Hans-CN": "国际语；西方语",
      "nl-NL": "Interlingue; Occidental",
      "es-ES": "Interlingue; Occidental",
      "sv-SE": "Interlingue; Occidental",
      "ru-RU": "Международный; Западный",
      "hu-HU": "Interlingue; Occidental",
    },
  },
  {
    code: "ig",
    label: {
      "en-US": "Igbo",
      "de-DE": "Igbo",
      "pt-BR": "Igbo",
      "fr-FR": "Igbo",
      "zh-Hant-TW": "伊博語",
      "pt-PT": "Igbo",
      "ro-RO": "Igbo",
      "ja-JP": "イグボ語",
      "zh-Hans-CN": "伊博语",
      "nl-NL": "Igbo",
      "es-ES": "Igbo",
      "sv-SE": "Igbo",
      "ru-RU": "Игбо",
      "hu-HU": "Igbo",
    },
  },
  {
    code: "ii",
    label: {
      "en-US": "Sichuan Yi; Nuosu",
      "de-DE": "Sichuan Yi; Nuosu",
      "pt-BR": "Sichuan Yi; Nuosu",
      "fr-FR": "Sichuan Yi; Nuosu",
      "zh-Hant-TW": "彝語；諾蘇語",
      "pt-PT": "Sichuan Yi; Nuosu",
      "ro-RO": "Sichuan Yi; Nuosu",
      "ja-JP": "四川彝語；諾蘇語",
      "zh-Hans-CN": "彝语；诺苏语",
      "nl-NL": "Sichuan Yi; Nuosu",
      "es-ES": "Sichuan Yi; Nuosu",
      "sv-SE": "Sichuan Yi; Nuosu",
      "ru-RU": "Сичуаньский; Носу",
      "hu-HU": "Sichuan Yi; Nuosu",
    },
  },
  {
    code: "ik",
    label: {
      "en-US": "Inupiaq",
      "de-DE": "Inupiaq",
      "pt-BR": "Inupiaq",
      "fr-FR": "Inupiaq",
      "zh-Hant-TW": "依努皮克語",
      "pt-PT": "Inupiaq",
      "ro-RO": "Inupiaq",
      "ja-JP": "イヌピアク語",
      "zh-Hans-CN": "依努皮克语",
      "nl-NL": "Inupiaq",
      "es-ES": "Inupiaq",
      "sv-SE": "Inupiaq",
      "ru-RU": "Инупиак",
      "hu-HU": "Inupiaq",
    },
  },
  {
    code: "io",
    label: {
      "en-US": "Ido",
      "de-DE": "Ido",
      "pt-BR": "Ido",
      "fr-FR": "Ido",
      "zh-Hant-TW": "伊多語",
      "pt-PT": "Ido",
      "ro-RO": "Ido",
      "ja-JP": "イド語",
      "zh-Hans-CN": "伊多语",
      "nl-NL": "Ido",
      "es-ES": "Ido",
      "sv-SE": "Ido",
      "ru-RU": "Идо",
      "hu-HU": "Ido",
    },
  },
  {
    code: "is",
    label: {
      "en-US": "Icelandic",
      "de-DE": "Isländisch",
      "pt-BR": "Islandês",
      "fr-FR": "Islandais",
      "zh-Hant-TW": "冰島語",
      "pt-PT": "Islandês",
      "ro-RO": "Islandeză",
      "ja-JP": "アイスランド語",
      "zh-Hans-CN": "冰岛语",
      "nl-NL": "Isländisch",
      "es-ES": "Islandés",
      "sv-SE": "Isländska",
      "ru-RU": "Исландский",
      "hu-HU": "Icelandic",
    },
  },
  {
    code: "it",
    label: {
      "en-US": "Italian",
      "de-DE": "Italienisch",
      "pt-BR": "Italiano",
      "fr-FR": "Italien",
      "zh-Hant-TW": "義大利語",
      "pt-PT": "Italiano",
      "ro-RO": "Italian",
      "ja-JP": "イタリア語",
      "zh-Hans-CN": "意大利语",
      "nl-NL": "Italiaans",
      "es-ES": "Italiano",
      "sv-SE": "Italienska",
      "ru-RU": "Итальянский",
      "hu-HU": "Italian",
    },
  },
  {
    code: "iu",
    label: {
      "en-US": "Inuktitut",
      "de-DE": "Inuktitut",
      "pt-BR": "Inuktitut",
      "fr-FR": "Inuktitut",
      "zh-Hant-TW": "因紐特語",
      "pt-PT": "Inuktitut",
      "ro-RO": "Inuktitut",
      "ja-JP": "イヌクティトット語",
      "zh-Hans-CN": "因纽特语",
      "nl-NL": "Inuktitut",
      "es-ES": "Inuktitut",
      "sv-SE": "Inuktitut",
      "ru-RU": "Инуктитут",
      "hu-HU": "Inuktitut",
    },
  },
  {
    code: "ja",
    label: {
      "en-US": "Japanese",
      "de-DE": "Japanisch",
      "pt-BR": "Japonês",
      "fr-FR": "Japonais",
      "zh-Hant-TW": "日語",
      "pt-PT": "Japonês",
      "ro-RO": "Japoneză",
      "ja-JP": "日本語",
      "zh-Hans-CN": "日语",
      "nl-NL": "Japans",
      "es-ES": "Japonés",
      "sv-SE": "Japanska",
      "ru-RU": "Японский",
      "hu-HU": "Japanese",
    },
  },
  {
    code: "jv",
    label: {
      "en-US": "Javanese",
      "de-DE": "Javanisch",
      "pt-BR": "Javonês",
      "fr-FR": "Javanais",
      "zh-Hant-TW": "爪哇語",
      "pt-PT": "Javonês",
      "ro-RO": "Javaneză",
      "ja-JP": "ジャワ語",
      "zh-Hans-CN": "爪哇语",
      "nl-NL": "Javaans",
      "es-ES": "Javonés",
      "sv-SE": "Javanesiska",
      "ru-RU": "Яванский",
      "hu-HU": "Javanese",
    },
  },
  {
    code: "ka",
    label: {
      "en-US": "Georgian",
      "de-DE": "Georgisch",
      "pt-BR": "Georgiano",
      "fr-FR": "Géorgien",
      "zh-Hant-TW": "喬治亞語",
      "pt-PT": "Georgiano",
      "ro-RO": "Georgian",
      "ja-JP": "ジョージア語",
      "zh-Hans-CN": "格鲁吉亚语",
      "nl-NL": "Georgisch",
      "es-ES": "Georgiano",
      "sv-SE": "Georgiska",
      "ru-RU": "Грузинский",
      "hu-HU": "Georgian",
    },
  },
  {
    code: "kg",
    label: {
      "en-US": "Kongo",
      "de-DE": "Kongo",
      "pt-BR": "Kongo",
      "fr-FR": "Kongo",
      "zh-Hant-TW": "剛果語",
      "pt-PT": "Kongo",
      "ro-RO": "Kongo",
      "ja-JP": "コンゴ語",
      "zh-Hans-CN": "刚果语",
      "nl-NL": "Kongo",
      "es-ES": "Kongo",
      "sv-SE": "Kongo",
      "ru-RU": "Конго",
      "hu-HU": "Kongo",
    },
  },
  {
    code: "ki",
    label: {
      "en-US": "Kikuyu; Gikuyu",
      "de-DE": "Kikuyu; Gikuyu",
      "pt-BR": "Kikuyu; Gikuyu",
      "fr-FR": "Kikuyu; Gikuyu",
      "zh-Hant-TW": "吉庫尤語",
      "pt-PT": "Kikuyu; Gikuyu",
      "ro-RO": "Kikuyu; Gikuyu",
      "ja-JP": "キクユ語；ギクユ語",
      "zh-Hans-CN": "吉库尤语",
      "nl-NL": "Kikuyu; Gikuyu",
      "es-ES": "Kikuyu; Gikuyu",
      "sv-SE": "Kikuyu; Gikuyu",
      "ru-RU": "Кикуйю; Кикуйю",
      "hu-HU": "Kikuyu; Gikuyu",
    },
  },
  {
    code: "kj",
    label: {
      "en-US": "Kuanyama; Kwanyama",
      "de-DE": "Kuanyama; Kwanyama",
      "pt-BR": "Kuanyama; Kwanyama",
      "fr-FR": "Kuanyama; Kwanyama",
      "zh-Hant-TW": "寬亞瑪語；寬亞瑪語",
      "pt-PT": "Kuanyama; Kwanyama",
      "ro-RO": "Kuanyama; Kwanyama",
      "ja-JP": "カワヤマ語；カワヤマ語",
      "zh-Hans-CN": "宽亚玛语；宽亚玛语",
      "nl-NL": "Kuanyama; Kwanyama",
      "es-ES": "Kuanyama; Kwanyama",
      "sv-SE": "Kuanyama; Kwanyama",
      "ru-RU": "Куаньяма; Куаньяма",
      "hu-HU": "Kuanyama; Kwanyama",
    },
  },
  {
    code: "kk",
    label: {
      "en-US": "Kazakh",
      "de-DE": "Kasachisch",
      "pt-BR": "Cazaque",
      "fr-FR": "Kazakh",
      "zh-Hant-TW": "哈薩克語",
      "pt-PT": "Cazaque",
      "ro-RO": "Kazah",
      "ja-JP": "カザフ語",
      "zh-Hans-CN": "哈萨克语",
      "nl-NL": "Kazachs",
      "es-ES": "Kazajo",
      "sv-SE": "Kazakiska",
      "ru-RU": "Казахский",
      "hu-HU": "Kazakh",
    },
  },
  {
    code: "kl",
    label: {
      "en-US": "Kalaallisut; Greenlandic",
      "de-DE": "Kalaallisut; Grönländisch",
      "pt-BR": "Kalaallisut; Groelândico",
      "fr-FR": "Kalaallisut; Groenlandais",
      "zh-Hant-TW": "格陵蘭語",
      "pt-PT": "Kalaallisut; Greenlandic",
      "ro-RO": "Kalaallisut; Greenlandic",
      "ja-JP": "カラリスット語（グリーンランド語）",
      "zh-Hans-CN": "格陵兰语",
      "nl-NL": "Kalaallisut; Groenlands",
      "es-ES": "Kalaallisut; Groenlandés",
      "sv-SE": "Kalaallisut; Grönländska",
      "ru-RU": "Каларлисут; Гренландский",
      "hu-HU": "Kalaallisut; Greenlandic",
    },
  },
  {
    code: "km",
    label: {
      "en-US": "Central Khmer",
      "de-DE": "Zentral-Khmer",
      "pt-BR": "Khmer central",
      "fr-FR": "Khmer central",
      "zh-Hant-TW": "中央高棉語",
      "pt-PT": "Khmer central",
      "ro-RO": "Khmer central",
      "ja-JP": "中央高棉語",
      "zh-Hans-CN": "中央高棉语",
      "nl-NL": "Khmer central",
      "es-ES": "Khmer central",
      "sv-SE": "Khmer central",
      "ru-RU": "Центральный кхмерский",
      "hu-HU": "Central Khmer",
    },
  },
  {
    code: "kn",
    label: {
      "en-US": "Kannada",
      "de-DE": "Kannada",
      "pt-BR": "Canarês",
      "fr-FR": "Kannada",
      "zh-Hant-TW": "卡納達語",
      "pt-PT": "Kannada",
      "ro-RO": "Kannada",
      "ja-JP": "カナダ語",
      "zh-Hans-CN": "卡纳达语",
      "nl-NL": "Kannada",
      "es-ES": "Kannada",
      "sv-SE": "Kannada",
      "ru-RU": "Канада",
      "hu-HU": "Kannada",
    },
  },
  {
    code: "ko",
    label: {
      "en-US": "Korean",
      "de-DE": "Koreanisch",
      "pt-BR": "Coreano",
      "fr-FR": "Coréen",
      "zh-Hant-TW": "韓語",
      "pt-PT": "Coreano",
      "ro-RO": "Coreeană",
      "ja-JP": "韓国語",
      "zh-Hans-CN": "韩语",
      "nl-NL": "Koreaans",
      "es-ES": "Coreano",
      "sv-SE": "Koreanska",
      "ru-RU": "Корейский",
      "hu-HU": "Korean",
    },
  },
  {
    code: "kr",
    label: {
      "en-US": "Kanuri",
      "de-DE": "Kanuri",
      "pt-BR": "Kanuri",
      "fr-FR": "Kanuri",
      "zh-Hant-TW": "卡努里語",
      "pt-PT": "Kanuri",
      "ro-RO": "Kanuri",
      "ja-JP": "カヌリ語",
      "zh-Hans-CN": "卡努里语",
      "nl-NL": "Kanuri",
      "es-ES": "Kanuri",
      "sv-SE": "Kanuri",
      "ru-RU": "Канури",
      "hu-HU": "Kanuri",
    },
  },
  {
    code: "ks",
    label: {
      "en-US": "Kashmiri",
      "de-DE": "Kashmiri",
      "pt-BR": "Kashmiri",
      "fr-FR": "Kashmiri",
      "zh-Hant-TW": "卡什米爾語",
      "pt-PT": "Kashmiri",
      "ro-RO": "Kashmiri",
      "ja-JP": "カシュミール語",
      "zh-Hans-CN": "克什米尔语",
      "nl-NL": "Kashmiri",
      "es-ES": "Kashmiri",
      "sv-SE": "Kashmiri",
      "ru-RU": "Кашмирский",
      "hu-HU": "Kashmiri",
    },
  },
  {
    code: "ku",
    label: {
      "en-US": "Kurdish",
      "de-DE": "Kurdisch",
      "pt-BR": "Curdo",
      "fr-FR": "Kurde",
      "zh-Hant-TW": "庫爾德語",
      "pt-PT": "Kurdish",
      "ro-RO": "Kurdish",
      "ja-JP": "クルド語",
      "zh-Hans-CN": "库尔德语",
      "nl-NL": "Kurdish",
      "es-ES": "Kurdish",
      "sv-SE": "Kurdisch",
      "ru-RU": "Курдский",
      "hu-HU": "Kurdish",
    },
  },
  {
    code: "kv",
    label: {
      "en-US": "Komi",
      "de-DE": "Komi",
      "pt-BR": "Komi",
      "fr-FR": "Komi",
      "zh-Hant-TW": "科米語",
      "pt-PT": "Komi",
      "ro-RO": "Komi",
      "ja-JP": "コミ語",
      "zh-Hans-CN": "科米语",
      "nl-NL": "Komi",
      "es-ES": "Komi",
      "sv-SE": "Komi",
      "ru-RU": "Коми",
      "hu-HU": "Komi",
    },
  },
  {
    code: "kw",
    label: {
      "en-US": "Cornish",
      "de-DE": "Kornisch",
      "pt-BR": "Cornualles",
      "fr-FR": "Cornouaillois",
      "zh-Hant-TW": "康瓦爾語",
      "pt-PT": "Cornualles",
      "ro-RO": "Cornish",
      "ja-JP": "コーンウェル語",
      "zh-Hans-CN": "康沃尔语",
      "nl-NL": "Cornish",
      "es-ES": "Cornish",
      "sv-SE": "Korniska",
      "ru-RU": "Корнуоллский",
      "hu-HU": "Cornish",
    },
  },
  {
    code: "ky",
    label: {
      "en-US": "Kirghiz; Kyrgyz",
      "de-DE": "Kirgisisch; Kirgisischer",
      "pt-BR": "Kirguiz; Quirguiz",
      "fr-FR": "Kirghiz; Kyrgyz",
      "zh-Hant-TW": "吉爾吉斯語",
      "pt-PT": "Kirghiz; Kyrgyz",
      "ro-RO": "Kirghiz; Kyrgyz",
      "ja-JP": "キルギス語；キルギス語",
      "zh-Hans-CN": "吉尔吉斯语",
      "nl-NL": "Kirghiz; Kyrgyz",
      "es-ES": "Kirghiz; Kyrgyz",
      "sv-SE": "Kirghiz; Kirghiz",
      "ru-RU": "Киргизский; Киргизский",
      "hu-HU": "Kirghiz; Kyrgyz",
    },
  },
  {
    code: "la",
    label: {
      "en-US": "Latin",
      "de-DE": "Lateinisch",
      "pt-BR": "Latim",
      "fr-FR": "Latin",
      "zh-Hant-TW": "拉丁語",
      "pt-PT": "Latim",
      "ro-RO": "Latină",
      "ja-JP": "ラテン語",
      "zh-Hans-CN": "拉丁语",
      "nl-NL": "Latin",
      "es-ES": "Latin",
      "sv-SE": "Latin",
      "ru-RU": "Латинский",
      "hu-HU": "Latin",
    },
  },
  {
    code: "lb",
    label: {
      "en-US": "Luxembourgish; Letzeburgesch",
      "de-DE": "Luxemburgisch; Letzeburgesch",
      "pt-BR": "Luxemburguês; Luxemburguês",
      "fr-FR": "Luxembourgeois; Letzeburgesch",
      "zh-Hant-TW": "盧森堡語",
      "pt-PT": "Luxembourgish; Letzeburgesch",
      "ro-RO": "Luxembourgish; Letzeburgesch",
      "ja-JP": "ルクセンブルグ語；ルクセンブルグ語",
      "zh-Hans-CN": "卢森堡语",
      "nl-NL": "Luxembourgish; Letzeburgesch",
      "es-ES": "Luxembourgish; Letzeburgesch",
      "sv-SE": "Luxemburgisch; Letzeburgesch",
      "ru-RU": "Люксембургский; Люксембургский",
      "hu-HU": "Luxembourgish; Letzeburgesch",
    },
  },
  {
    code: "lg",
    label: {
      "en-US": "Ganda",
      "de-DE": "Ganda",
      "pt-BR": "Ganda",
      "fr-FR": "Ganda",
      "zh-Hant-TW": "干達語",
      "pt-PT": "Ganda",
      "ro-RO": "Ganda",
      "ja-JP": "ガンダ語",
      "zh-Hans-CN": "卢干达语",
      "nl-NL": "Ganda",
      "es-ES": "Ganda",
      "sv-SE": "Ganda",
      "ru-RU": "Ганда",
      "hu-HU": "Ganda",
    },
  },
  {
    code: "li",
    label: {
      "en-US": "Limburgan; Limburger; Limburgish",
      "de-DE": "Limburgisch; Limburger; Limburgish",
      "pt-BR": "Limburguês; Limburguês; Limburguês",
      "fr-FR": "Limbourgeois; Limbourgeois; Limbourgeois",
      "zh-Hant-TW": "林堡語",
      "pt-PT": "Limburgan; Limburger; Limburgish",
      "ro-RO": "Limburgan; Limburger; Limburgish",
      "ja-JP": "リムブルガン語；リムブルガン語；リムブルガン語",
      "zh-Hans-CN": "林堡语",
      "nl-NL": "Limburgan; Limburger; Limburgish",
      "es-ES": "Limburgan; Limburger; Limburgish",
      "sv-SE": "Limburgisch; Limburger; Limburgish",
      "ru-RU": "Лимбургский; Лимбургский; Лимбургский",
      "hu-HU": "Limburgan; Limburger; Limburgish",
    },
  },
  {
    code: "ln",
    label: {
      "en-US": "Lingala",
      "de-DE": "Lingala",
      "pt-BR": "Lingala",
      "fr-FR": "Lingala",
      "zh-Hant-TW": "林加拉語",
      "pt-PT": "Lingala",
      "ro-RO": "Lingala",
      "ja-JP": "リンガラ語",
      "zh-Hans-CN": "林加拉语",
      "nl-NL": "Lingala",
      "es-ES": "Lingala",
      "sv-SE": "Lingala",
      "ru-RU": "Лингала",
      "hu-HU": "Lingala",
    },
  },
  {
    code: "lo",
    label: {
      "en-US": "Lao",
      "de-DE": "Lao",
      "pt-BR": "Lao",
      "fr-FR": "Lao",
      "zh-Hant-TW": "寮語",
      "pt-PT": "Lao",
      "ro-RO": "Lao",
      "ja-JP": "ラオ語",
      "zh-Hans-CN": "老挝语",
      "nl-NL": "Lao",
      "es-ES": "Lao",
      "sv-SE": "Lao",
      "ru-RU": "Лаосский",
      "hu-HU": "Lao",
    },
  },
  {
    code: "lt",
    label: {
      "en-US": "Lithuanian",
      "de-DE": "Litauisch",
      "pt-BR": "Lituano",
      "fr-FR": "Lituanien",
      "zh-Hant-TW": "立陶宛語",
      "pt-PT": "Lituaniano",
      "ro-RO": "Lituaniană",
      "ja-JP": "リトアニア語",
      "zh-Hans-CN": "立陶宛语",
      "nl-NL": "Lithuanian",
      "es-ES": "Lituano",
      "sv-SE": "Litauiska",
      "ru-RU": "Литовский",
      "hu-HU": "Lithuanian",
    },
  },
  {
    code: "lu",
    label: {
      "en-US": "Luba-Katanga",
      "de-DE": "Luba-Katanga",
      "pt-BR": "Luba-Katanga",
      "fr-FR": "Luba-Katanga",
      "zh-Hant-TW": "盧巴-加丹加語",
      "pt-PT": "Luba-Katanga",
      "ro-RO": "Luba-Katanga",
      "ja-JP": "ルバ・カタンガ語",
      "zh-Hans-CN": "卢巴-加丹加语",
      "nl-NL": "Luba-Katanga",
      "es-ES": "Luba-Katanga",
      "sv-SE": "Luba-Katanga",
      "ru-RU": "Луба-Катанга",
      "hu-HU": "Luba-Katanga",
    },
  },
  {
    code: "lv",
    label: {
      "en-US": "Latvian",
      "de-DE": "Lettisch",
      "pt-BR": "Letão",
      "fr-FR": "Letton",
      "zh-Hant-TW": "拉脫維亞語",
      "pt-PT": "Letão",
      "ro-RO": "Letonă",
      "ja-JP": "ラトビア語",
      "zh-Hans-CN": "拉脱维亚语",
      "nl-NL": "Latvian",
      "es-ES": "Letón",
      "sv-SE": "Lettiska",
      "ru-RU": "Латвийский",
      "hu-HU": "Latvian",
    },
  },
  {
    code: "mg",
    label: {
      "en-US": "Malagasy",
      "de-DE": "Malagasy",
      "pt-BR": "Malagasy",
      "fr-FR": "Malagasy",
      "zh-Hant-TW": "馬拉加斯語",
      "pt-PT": "Malagasy",
      "ro-RO": "Malagasy",
      "ja-JP": "マラガシア語",
      "zh-Hans-CN": "马达加斯加语",
      "nl-NL": "Malagasy",
      "es-ES": "Malagasy",
      "sv-SE": "Malagasy",
      "ru-RU": "Малагасийский",
      "hu-HU": "Malagasy",
    },
  },
  {
    code: "mh",
    label: {
      "en-US": "Marshallese",
      "de-DE": "Marshallese",
      "pt-BR": "Marshallês",
      "fr-FR": "Marshallese",
      "zh-Hant-TW": "馬紹爾語",
      "pt-PT": "Marshallese",
      "ro-RO": "Marshallese",
      "ja-JP": "マーシャル諸島語",
      "zh-Hans-CN": "马绍尔语",
      "nl-NL": "Marshallese",
      "es-ES": "Marshallese",
      "sv-SE": "Marshallese",
      "ru-RU": "Маврикийский",
      "hu-HU": "Marshallese",
    },
  },
  {
    code: "mi",
    label: {
      "en-US": "Maori",
      "de-DE": "Maori",
      "pt-BR": "Maori",
      "fr-FR": "Maori",
      "zh-Hant-TW": "毛利語",
      "pt-PT": "Maori",
      "ro-RO": "Maori",
      "ja-JP": "マオリ語",
      "zh-Hans-CN": "毛利语",
      "nl-NL": "Maori",
      "es-ES": "Maori",
      "sv-SE": "Maori",
      "ru-RU": "Маори",
      "hu-HU": "Maori",
    },
  },
  {
    code: "mk",
    label: {
      "en-US": "Macedonian",
      "de-DE": "Mazedonisch",
      "pt-BR": "Macedônio",
      "fr-FR": "Macédonien",
      "zh-Hant-TW": "馬其頓語",
      "pt-PT": "Macedónio",
      "ro-RO": "Macedonian",
      "ja-JP": "マケドニア語",
      "zh-Hans-CN": "马其顿语",
      "nl-NL": "Macedonian",
      "es-ES": "Macedonian",
      "sv-SE": "Makedonska",
      "ru-RU": "Македонский",
      "hu-HU": "Macedonian",
    },
  },
  {
    code: "ml",
    label: {
      "en-US": "Malayalam",
      "de-DE": "Malayalam",
      "pt-BR": "Malayalam",
      "fr-FR": "Malayalam",
      "zh-Hant-TW": "馬拉雅拉姆語",
      "pt-PT": "Malayalam",
      "ro-RO": "Malayalam",
      "ja-JP": "マラヤラム語",
      "zh-Hans-CN": "马拉雅拉姆语",
      "nl-NL": "Malayalam",
      "es-ES": "Malayalam",
      "sv-SE": "Malayalam",
      "ru-RU": "Малаялам",
      "hu-HU": "Malayalam",
    },
  },
  {
    code: "mn",
    label: {
      "en-US": "Mongolian",
      "de-DE": "Mongolisch",
      "pt-BR": "Mongol",
      "fr-FR": "Mongol",
      "zh-Hant-TW": "蒙古語",
      "pt-PT": "Mongol",
      "ro-RO": "Mongol",
      "ja-JP": "モンゴル語",
      "zh-Hans-CN": "蒙古语",
      "nl-NL": "Mongolian",
      "es-ES": "Mongolian",
      "sv-SE": "Mongolian",
      "ru-RU": "Монгольский",
      "hu-HU": "Mongolian",
    },
  },
  {
    code: "mr",
    label: {
      "en-US": "Marathi",
      "de-DE": "Marathi",
      "pt-BR": "Marati",
      "fr-FR": "Marathi",
      "zh-Hant-TW": "馬拉地語",
      "pt-PT": "Marathi",
      "ro-RO": "Marathi",
      "ja-JP": "マラーティ語",
      "zh-Hans-CN": "马拉地语",
      "nl-NL": "Marathi",
      "es-ES": "Marathi",
      "sv-SE": "Marathi",
      "ru-RU": "Маратхи",
      "hu-HU": "Marathi",
    },
  },
  {
    code: "ms",
    label: {
      "en-US": "Malay",
      "de-DE": "Malay",
      "pt-BR": "Malaio",
      "fr-FR": "Malais",
      "zh-Hant-TW": "馬來語",
      "pt-PT": "Malay",
      "ro-RO": "Malay",
      "ja-JP": "マレー語",
      "zh-Hans-CN": "马来语",
      "nl-NL": "Malay",
      "es-ES": "Malay",
      "sv-SE": "Malay",
      "ru-RU": "Малайский",
      "hu-HU": "Malay",
    },
  },
  {
    code: "mt",
    label: {
      "en-US": "Maltese",
      "de-DE": "Maltesisch",
      "pt-BR": "Maltês",
      "fr-FR": "Maltès",
      "zh-Hant-TW": "馬爾他語",
      "pt-PT": "Maltês",
      "ro-RO": "Maltese",
      "ja-JP": "マルタ語",
      "zh-Hans-CN": "马耳他语",
      "nl-NL": "Maltese",
      "es-ES": "Maltese",
      "sv-SE": "Maltesiska",
      "ru-RU": "Мальтийский",
      "hu-HU": "Maltese",
    },
  },
  {
    code: "my",
    label: {
      "en-US": "Burmese",
      "de-DE": "Birmanisch",
      "pt-BR": "Birmanês",
      "fr-FR": "Birman",
      "zh-Hant-TW": "緬甸語",
      "pt-PT": "Birmanês",
      "ro-RO": "Birman",
      "ja-JP": "ビルマ語",
      "zh-Hans-CN": "缅甸语",
      "nl-NL": "Burmese",
      "es-ES": "Burmese",
      "sv-SE": "Burmesiska",
      "ru-RU": "Бирманский",
      "hu-HU": "Burmese",
    },
  },
  {
    code: "na",
    label: {
      "en-US": "Nauru",
      "de-DE": "Nauru",
      "pt-BR": "Nauru",
      "fr-FR": "Nauru",
      "zh-Hant-TW": "諾魯語",
      "pt-PT": "Nauru",
      "ro-RO": "Nauru",
      "ja-JP": "ナウル語",
      "zh-Hans-CN": "瑙鲁语",
      "nl-NL": "Nauru",
      "es-ES": "Nauru",
      "sv-SE": "Nauru",
      "ru-RU": "Науру",
      "hu-HU": "Nauru",
    },
  },
  {
    code: "nb",
    label: {
      "en-US": "Bokmål, Norwegian; Norwegian Bokmål",
      "de-DE": "Bokmål, Norwegisch; Norwegische Bokmål",
      "pt-BR": "Bokmål, Norueguês; Bokmål Norueguês",
      "fr-FR": "Bokmål, Norvégien; Bokmål Norvégien",
      "zh-Hant-TW": "巴克摩挪威語；挪威巴克摩語",
      "pt-PT": "Bokmål, Norueguês; Bokmål Norueguês",
      "ro-RO": "Bokmål, Norueguês; Bokmål Norueguês",
      "ja-JP": "ノルウェー語（ブークモール）",
      "zh-Hans-CN": "书面挪威语（博克马尔）",
      "nl-NL": "Bokmål, Norwegian; Norwegian Bokmål",
      "es-ES": "Bokmål, Norueguês; Bokmål Norueguês",
      "sv-SE": "Bokmål, Norsk; Norsk Bokmål",
      "ru-RU": "Букмол, Норвежский; Норвежский Букмол",
      "hu-HU": "Bokmål, Norwegian; Norwegian Bokmål",
    },
  },
  {
    code: "nd",
    label: {
      "en-US": "Ndebele, North; North Ndebele",
      "de-DE": "Ndebele, Nord; Nord Ndebele",
      "pt-BR": "Ndebele, Norte; Norte Ndebele",
      "fr-FR": "Ndebele, Nord; Nord Ndebele",
      "zh-Hant-TW": "北恩德貝萊語；北恩德貝萊語",
      "pt-PT": "Ndebele, Norte; Norte Ndebele",
      "ro-RO": "Ndebele, Nord; Nord Ndebele",
      "ja-JP": "ナンデベレ語 北方言；北ナンデベレ語",
      "zh-Hans-CN": "北恩德贝勒语",
      "nl-NL": "Ndebele, North; North Ndebele",
      "es-ES": "Ndebele, Norte; Norte Ndebele",
      "sv-SE": "Ndebele, Nord; Nord Ndebele",
      "ru-RU": "Ндебеле, Север; Север Ндебеле",
      "hu-HU": "Ndebele, North; North Ndebele",
    },
  },
  {
    code: "ne",
    label: {
      "en-US": "Nepali",
      "de-DE": "Nepali",
      "pt-BR": "Nepali",
      "fr-FR": "Népalais",
      "zh-Hant-TW": "尼泊爾語",
      "pt-PT": "Nepali",
      "ro-RO": "Nepali",
      "ja-JP": "ネパール語",
      "zh-Hans-CN": "尼泊尔语",
      "nl-NL": "Nepali",
      "es-ES": "Nepali",
      "sv-SE": "Nepali",
      "ru-RU": "Непальский",
      "hu-HU": "Nepali",
    },
  },
  {
    code: "ng",
    label: {
      "en-US": "Ndonga",
      "de-DE": "Ndonga",
      "pt-BR": "Ndonga",
      "fr-FR": "Ndonga",
      "zh-Hant-TW": "恩敦加語",
      "pt-PT": "Ndonga",
      "ro-RO": "Ndonga",
      "ja-JP": "ンドンガ語",
      "zh-Hans-CN": "恩敦加语",
      "nl-NL": "Ndonga",
      "es-ES": "Ndonga",
      "sv-SE": "Ndonga",
      "ru-RU": "Ндонга",
      "hu-HU": "Ndonga",
    },
  },
  {
    code: "nl",
    label: {
      "en-US": "Dutch; Flemish",
      "de-DE": "Holländisch; Flämisch",
      "pt-BR": "Holandês; Flamengo",
      "fr-FR": "Néerlandais; Flamand",
      "zh-Hant-TW": "荷蘭語；法蘭德斯語",
      "pt-PT": "Holandês; Flamengo",
      "ro-RO": "Olandeză; Flamandă",
      "ja-JP": "オランダ語；フラマン語",
      "zh-Hans-CN": "荷兰语；弗拉芒语",
      "nl-NL": "Nederlands; Vlaams",
      "es-ES": "Holandés; Flamenco",
      "sv-SE": "Nederlands; Vlaams",
      "ru-RU": "Голландский; Фламандский",
      "hu-HU": "Dutch; Flemish",
    },
  },
  {
    code: "nn",
    label: {
      "en-US": "Norwegian Nynorsk; Nynorsk, Norwegian",
      "de-DE": "Norwegische Nynorsk; Nynorsk, Norwegisch",
      "pt-BR": "Norwegian Nynorsk; Nynorsk, Norueguês",
      "fr-FR": "Norvégien Nynorsk; Nynorsk, Norvégien",
      "zh-Hant-TW": "挪威尼諾斯克語；尼諾斯克語，挪威語",
      "pt-PT": "Norwegian Nynorsk; Nynorsk, Norwegian",
      "ro-RO": "Norvegian Nynorsk; Nynorsk, Norvegian",
      "ja-JP": "ノルウェー語（ニーノシュク）",
      "zh-Hans-CN": "新挪威语（尼诺斯克）",
      "nl-NL": "Norwegian Nynorsk; Nynorsk, Norwegian",
      "es-ES": "Norwegian Nynorsk; Nynorsk, Norwegian",
      "sv-SE": "Norsk nynorsk; Nynorsk, Norsk",
      "ru-RU": "Норвежский Ньюнорск; Ньюнорск, Норвежский",
      "hu-HU": "Norwegian Nynorsk; Nynorsk, Norwegian",
    },
  },
  {
    code: "no",
    label: {
      "en-US": "Norwegian",
      "de-DE": "Norwegisch",
      "pt-BR": "Norueguês",
      "fr-FR": "Norvégien",
      "zh-Hant-TW": "挪威語",
      "pt-PT": "Norueguês",
      "ro-RO": "Norvegian",
      "ja-JP": "ノルウェー語",
      "zh-Hans-CN": "挪威语",
      "nl-NL": "Norwegisch",
      "es-ES": "Noruego",
      "sv-SE": "Norsk",
      "ru-RU": "Норвежский",
      "hu-HU": "Norwegian",
    },
  },
  {
    code: "nr",
    label: {
      "en-US": "Ndebele, South; South Ndebele",
      "de-DE": "Ndebele, Süd; Süd Ndebele",
      "pt-BR": "Ndebele, Sul; Sul Ndebele",
      "fr-FR": "Ndebele, Sud; Sud Ndebele",
      "zh-Hant-TW": "南恩德貝萊語",
      "pt-PT": "Ndebele, Sul; Sul Ndebele",
      "ro-RO": "Ndebele, Sud; Sud Ndebele",
      "ja-JP": "ナンデベレ語",
      "zh-Hans-CN": "南恩德贝勒语",
      "nl-NL": "Ndebele, South; South Ndebele",
      "es-ES": "Ndebele, Sul; Sul Ndebele",
      "sv-SE": "Ndebele, Sør; Sør Ndebele",
      "ru-RU": "Ндебеле, Юг; Юг Ндебеле",
      "hu-HU": "Ndebele, South; South Ndebele",
    },
  },
  {
    code: "nv",
    label: {
      "en-US": "Navajo; Navaho",
      "de-DE": "Navajo; Navaho",
      "pt-BR": "Navajo; Navaho",
      "fr-FR": "Navajo; Navaho",
      "zh-Hant-TW": "納瓦荷語",
      "pt-PT": "Navajo; Navaho",
      "ro-RO": "Navajo; Navaho",
      "ja-JP": "ナバホ語",
      "zh-Hans-CN": "纳瓦霍语",
      "nl-NL": "Navajo; Navaho",
      "es-ES": "Navajo; Navaho",
      "sv-SE": "Navajo; Navaho",
      "ru-RU": "Навахо; Навахо",
      "hu-HU": "Navajo; Navaho",
    },
  },
  {
    code: "ny",
    label: {
      "en-US": "Chichewa; Chewa; Nyanja",
      "de-DE": "Chichewa; Chewa; Nyanja",
      "pt-BR": "Chichewa; Chewa; Nyanja",
      "fr-FR": "Chichewa; Chewa; Nyanja",
      "zh-Hant-TW": "齊切瓦語；契瓦語；尼揚加語",
      "pt-PT": "Chichewa; Chewa; Nyanja",
      "ro-RO": "Chichewa; Chewa; Nyanja",
      "ja-JP": "チェワ語",
      "zh-Hans-CN": "齐切瓦语；契瓦语；尼扬加语",
      "nl-NL": "Chichewa; Chewa; Nyanja",
      "es-ES": "Chichewa; Chewa; Nyanja",
      "sv-SE": "Chichewa; Chewa; Nyanja",
      "ru-RU": "Чичева; Чева; Нянжа",
      "hu-HU": "Chichewa; Chewa; Nyanja",
    },
  },
  {
    code: "oc",
    label: {
      "en-US": "Occitan (post 1500)",
      "de-DE": "Occitan (post 1500)",
      "pt-BR": "Occitano (pós 1500)",
      "fr-FR": "Occitan (post 1500)",
      "zh-Hant-TW": "奧克語（1500 年後）",
      "pt-PT": "Occitano (pós 1500)",
      "ro-RO": "Occitano (pós 1500)",
      "ja-JP": "オック語（1500年以降）",
      "zh-Hans-CN": "奥克语（1500年后）",
      "nl-NL": "Occitano (pós 1500)",
      "es-ES": "Occitano (pós 1500)",
      "sv-SE": "Occitano (pós 1500)",
      "ru-RU": "Окситанский (после 1500)",
      "hu-HU": "Occitan (post 1500)",
    },
  },
  {
    code: "oj",
    label: {
      "en-US": "Ojibwa",
      "de-DE": "Ojibwa",
      "pt-BR": "Ojibwa",
      "fr-FR": "Ojibwa",
      "zh-Hant-TW": "奧吉布瓦語",
      "pt-PT": "Ojibwa",
      "ro-RO": "Ojibwa",
      "ja-JP": "オジブワ語",
      "zh-Hans-CN": "奥吉布瓦语",
      "nl-NL": "Ojibwa",
      "es-ES": "Ojibwa",
      "sv-SE": "Ojibwa",
      "ru-RU": "Оджибве",
      "hu-HU": "Ojibwa",
    },
  },
  {
    code: "om",
    label: {
      "en-US": "Oromo",
      "de-DE": "Oromo",
      "pt-BR": "Oromo",
      "fr-FR": "Oromo",
      "zh-Hant-TW": "奧羅莫語",
      "pt-PT": "Oromo",
      "ro-RO": "Oromo",
      "ja-JP": "オロモ語",
      "zh-Hans-CN": "奥罗莫语",
      "nl-NL": "Oromo",
      "es-ES": "Oromo",
      "sv-SE": "Oromo",
      "ru-RU": "Оромо",
      "hu-HU": "Oromo",
    },
  },
  {
    code: "or",
    label: {
      "en-US": "Oriya",
      "de-DE": "Oriya",
      "pt-BR": "Oriya",
      "fr-FR": "Oriya",
      "zh-Hant-TW": "奧里亞語",
      "pt-PT": "Oriya",
      "ro-RO": "Oriya",
      "ja-JP": "オリヤ語",
      "zh-Hans-CN": "奥里亚语",
      "nl-NL": "Oriya",
      "es-ES": "Oriya",
      "sv-SE": "Oriya",
      "ru-RU": "Ория",
      "hu-HU": "Oriya",
    },
  },
  {
    code: "os",
    label: {
      "en-US": "Ossetian; Ossetic",
      "de-DE": "Ossetian; Ossetic",
      "pt-BR": "Ossetiano; Ossético",
      "fr-FR": "Ossète; Ossète",
      "zh-Hant-TW": "奧塞提亞語",
      "pt-PT": "Ossetian; Ossetic",
      "ro-RO": "Ossetian; Ossetic",
      "ja-JP": "オセティア語",
      "zh-Hans-CN": "奥塞梯语",
      "nl-NL": "Ossetian; Ossetic",
      "es-ES": "Ossetian; Ossetic",
      "sv-SE": "Ossetian; Ossetic",
      "ru-RU": "Осетинский; Осетинский",
      "hu-HU": "Ossetian; Ossetic",
    },
  },
  {
    code: "pa",
    label: {
      "en-US": "Panjabi; Punjabi",
      "de-DE": "Panjabi; Punjabi",
      "pt-BR": "Panjabi; Punjabi",
      "fr-FR": "Panjabi; Punjabi",
      "zh-Hant-TW": "旁遮普語",
      "pt-PT": "Panjabi; Punjabi",
      "ro-RO": "Panjabi; Punjabi",
      "ja-JP": "パンジャブ語",
      "zh-Hans-CN": "旁遮普语",
      "nl-NL": "Panjabi; Punjabi",
      "es-ES": "Panjabi; Punjabi",
      "sv-SE": "Panjabi; Punjabi",
      "ru-RU": "Панджаби; Панджаби",
      "hu-HU": "Panjabi; Punjabi",
    },
  },
  {
    code: "pi",
    label: {
      "en-US": "Pali",
      "de-DE": "Pali",
      "pt-BR": "Pali",
      "fr-FR": "Pali",
      "zh-Hant-TW": "巴利語",
      "pt-PT": "Pali",
      "ro-RO": "Pali",
      "ja-JP": "パーリ語",
      "zh-Hans-CN": "巴利语",
      "nl-NL": "Pali",
      "es-ES": "Pali",
      "sv-SE": "Pali",
      "ru-RU": "Пали",
      "hu-HU": "Pali",
    },
  },
  {
    code: "pl",
    label: {
      "en-US": "Polish",
      "de-DE": "Polnisch",
      "pt-BR": "Polonês",
      "fr-FR": "Polonais",
      "zh-Hant-TW": "波蘭語",
      "pt-PT": "Polonês",
      "ro-RO": "Polish",
      "ja-JP": "ポーランド語",
      "zh-Hans-CN": "波兰语",
      "nl-NL": "Polnisch",
      "es-ES": "Polaco",
      "sv-SE": "Polnisch",
      "ru-RU": "Польский",
      "hu-HU": "Polish",
    },
  },
  {
    code: "ps",
    label: {
      "en-US": "Pushto; Pashto",
      "de-DE": "Pushto; Pashto",
      "pt-BR": "Pushto; Pashto",
      "fr-FR": "Poushto; Pashto",
      "zh-Hant-TW": "普什圖語",
      "pt-PT": "Pushto; Pashto",
      "ro-RO": "Pushto; Pashto",
      "ja-JP": "パシュトゥー語",
      "zh-Hans-CN": "普什图语",
      "nl-NL": "Pushto; Pashto",
      "es-ES": "Pushto; Pashto",
      "sv-SE": "Pushto; Pashto",
      "ru-RU": "Пушту; Пушту",
      "hu-HU": "Pushto; Pashto",
    },
  },
  {
    code: "pt",
    label: {
      "en-US": "Portuguese",
      "de-DE": "Portugiesisch",
      "pt-BR": "Português",
      "fr-FR": "Portugais",
      "zh-Hant-TW": "葡萄牙語",
      "pt-PT": "Português",
      "ro-RO": "Portuguese",
      "ja-JP": "ポルトガル語",
      "zh-Hans-CN": "葡萄牙语",
      "nl-NL": "Portugees",
      "es-ES": "Portugués",
      "sv-SE": "Portugisiska",
      "ru-RU": "Португальский",
      "hu-HU": "Portuguese",
    },
  },
  {
    code: "pt-BR",
    label: {
      "en-US": "Portuguese (Brazil)",
      "de-DE": "Portugiesisch (Brasilien)",
      "pt-BR": "Português (Brasil)",
      "fr-FR": "Portugais (Brésil)",
      "zh-Hant-TW": "葡萄牙語（巴西）",
      "pt-PT": "Português (Brasil)",
      "ro-RO": "Portugheză (Brazilia)",
      "ja-JP": "ポルトガル語（ブラジル）",
      "zh-Hans-CN": "葡萄牙语（巴西）",
      "nl-NL": "Portugees (Brazilië)",
      "es-ES": "Portugués (Brasil)",
      "sv-SE": "Portugisiska (Brasilien)",
      "ru-RU": "Португальский (Бразилия)",
      "hu-HU": "Portuguese (Brazil)",
    },
  },
  {
    code: "pt-PT",
    label: {
      "en-US": "Portuguese (Portugal)",
      "de-DE": "Portugiesisch (Portugal)",
      "pt-BR": "Português (Portugal)",
      "fr-FR": "Portugais (Portugal)",
      "zh-Hant-TW": "葡萄牙語（葡萄牙）",
      "pt-PT": "Português (Portugal)",
      "ro-RO": "Portugheză (Portugalia)",
      "ja-JP": "ポルトガル語（ポルトガル）",
      "zh-Hans-CN": "葡萄牙语（葡萄牙）",
      "nl-NL": "Portugees (Portugal)",
      "es-ES": "Portugués (Portugal)",
      "sv-SE": "Portugisiska (Portugal)",
      "ru-RU": "Португальский (Португалия)",
      "hu-HU": "Portuguese (Portugal)",
    },
  },
  {
    code: "qu",
    label: {
      "en-US": "Quechua",
      "de-DE": "Quechua",
      "pt-BR": "Quechua",
      "fr-FR": "Quechua",
      "zh-Hant-TW": "蓋丘亞語",
      "pt-PT": "Quechua",
      "ro-RO": "Quechua",
      "ja-JP": "ケチュア語",
      "zh-Hans-CN": "克丘亚语",
      "nl-NL": "Quechua",
      "es-ES": "Quechua",
      "sv-SE": "Quechua",
      "ru-RU": "Кечуа",
      "hu-HU": "Quechua",
    },
  },
  {
    code: "rm",
    label: {
      "en-US": "Romansh",
      "de-DE": "Rämisch",
      "pt-BR": "Romeno",
      "fr-FR": "Romansh",
      "zh-Hant-TW": "羅曼什語",
      "pt-PT": "Romansh",
      "ro-RO": "Romansh",
      "ja-JP": "ロマンシュ語",
      "zh-Hans-CN": "罗曼什语",
      "nl-NL": "Romansh",
      "es-ES": "Romansh",
      "sv-SE": "Romansh",
      "ru-RU": "Румынский",
      "hu-HU": "Romansh",
    },
  },
  {
    code: "rn",
    label: {
      "en-US": "Rundi",
      "de-DE": "Rundi",
      "pt-BR": "Rundi",
      "fr-FR": "Rundi",
      "zh-Hant-TW": "盧安達語",
      "pt-PT": "Rundi",
      "ro-RO": "Rundi",
      "ja-JP": "ルンデ語",
      "zh-Hans-CN": "隆迪语（基隆迪语）",
      "nl-NL": "Rundi",
      "es-ES": "Rundi",
      "sv-SE": "Rundi",
      "ru-RU": "Рунди",
      "hu-HU": "Rundi",
    },
  },
  {
    code: "ro",
    label: {
      "en-US": "Romanian; Moldavian; Moldovan",
      "de-DE": "Rumänisch; Moldauisch; Moldauisch",
      "pt-BR": "Romeno; Moldavo; Moldavo",
      "fr-FR": "Roumain; Moldave; Moldave",
      "zh-Hant-TW": "羅馬尼亞語；摩爾多瓦語",
      "pt-PT": "Romeno; Moldavo; Moldavo",
      "ro-RO": "Română; Moldovenească; Moldovenească",
      "ja-JP": "ルーマニア語",
      "zh-Hans-CN": "罗马尼亚语；摩尔多瓦语",
      "nl-NL": "Roemeens; Moldavisch",
      "es-ES": "Rumano; Moldavo",
      "sv-SE": "Rumänska; Moldaviska",
      "ru-RU": "Румынский; Молдавский; Молдавский",
      "hu-HU": "Romanian; Moldavian; Moldovan",
    },
  },
  {
    code: "ru",
    label: {
      "en-US": "Russian",
      "de-DE": "Russisch",
      "pt-BR": "Russo",
      "fr-FR": "Russe",
      "zh-Hant-TW": "俄語",
      "pt-PT": "Russo",
      "ro-RO": "Rusă",
      "ja-JP": "ロシア語",
      "zh-Hans-CN": "俄语",
      "nl-NL": "Russisch",
      "es-ES": "Ruso",
      "sv-SE": "Ryska",
      "ru-RU": "Русский",
      "hu-HU": "Russian",
    },
  },
  {
    code: "rw",
    label: {
      "en-US": "Kinyarwanda",
      "de-DE": "Kinyarwanda",
      "pt-BR": "Kinyarwanda",
      "fr-FR": "Kinyarwanda",
      "zh-Hant-TW": "盧安達語",
      "pt-PT": "Kinyarwanda",
      "ro-RO": "Kinyarwanda",
      "ja-JP": "キニャランダ語",
      "zh-Hans-CN": "卢旺达语",
      "nl-NL": "Kinyarwanda",
      "es-ES": "Kinyarwanda",
      "sv-SE": "Kinyarwanda",
      "ru-RU": "Киняруанда",
      "hu-HU": "Kinyarwanda",
    },
  },
  {
    code: "sa",
    label: {
      "en-US": "Sanskrit",
      "de-DE": "Sanskrit",
      "pt-BR": "Sânscrito",
      "fr-FR": "Sanskrit",
      "zh-Hant-TW": "梵語",
      "pt-PT": "Sanskrit",
      "ro-RO": "Sanskrit",
      "ja-JP": "サンスクリット語",
      "zh-Hans-CN": "梵语",
      "nl-NL": "Sanskrit",
      "es-ES": "Sanskrit",
      "sv-SE": "Sanskrit",
      "ru-RU": "Санскрит",
      "hu-HU": "Sanskrit",
    },
  },
  {
    code: "sc",
    label: {
      "en-US": "Sardinian",
      "de-DE": "Sardisch",
      "pt-BR": "Sardo",
      "fr-FR": "Sardien",
      "zh-Hant-TW": "薩丁尼亞語",
      "pt-PT": "Sardo",
      "ro-RO": "Sardo",
      "ja-JP": "サルデーニャ語",
      "zh-Hans-CN": "撒丁尼亚语",
      "nl-NL": "Sardo",
      "es-ES": "Sardo",
      "sv-SE": "Sardisch",
      "ru-RU": "Саардинский",
      "hu-HU": "Sardinian",
    },
  },
  {
    code: "sd",
    label: {
      "en-US": "Sindhi",
      "de-DE": "Sindhi",
      "pt-BR": "Sindhi",
      "fr-FR": "Sindhi",
      "zh-Hant-TW": "信德語",
      "pt-PT": "Sindhi",
      "ro-RO": "Sindhi",
      "ja-JP": "シンディ語",
      "zh-Hans-CN": "信德语",
      "nl-NL": "Sindhi",
      "es-ES": "Sindhi",
      "sv-SE": "Sindhi",
      "ru-RU": "Синдхи",
      "hu-HU": "Sindhi",
    },
  },
  {
    code: "se",
    label: {
      "en-US": "Northern Sami",
      "de-DE": "Nordischer Sami",
      "pt-BR": "Sami do Norte",
      "fr-FR": "Sami du Nord",
      "zh-Hant-TW": "北薩米語",
      "pt-PT": "Sami do Norte",
      "ro-RO": "Sami do Norte",
      "ja-JP": "北サミ語",
      "zh-Hans-CN": "北萨米语",
      "nl-NL": "Sami do Norte",
      "es-ES": "Sami do Norte",
      "sv-SE": "Sami do Norte",
      "ru-RU": "Северный саами",
      "hu-HU": "Northern Sami",
    },
  },
  {
    code: "sg",
    label: {
      "en-US": "Sango",
      "de-DE": "Sango",
      "pt-BR": "Sango",
      "fr-FR": "Sango",
      "zh-Hant-TW": "桑戈語",
      "pt-PT": "Sango",
      "ro-RO": "Sango",
      "ja-JP": "サンゴ語",
      "zh-Hans-CN": "桑戈语",
      "nl-NL": "Sango",
      "es-ES": "Sango",
      "sv-SE": "Sango",
      "ru-RU": "Санго",
      "hu-HU": "Sango",
    },
  },
  {
    code: "si",
    label: {
      "en-US": "Sinhala; Sinhalese",
      "de-DE": "Sinhala; Sinhalese",
      "pt-BR": "Sinhala; Sinhalese",
      "fr-FR": "Sinhala; Sinhalese",
      "zh-Hant-TW": "僧伽羅語",
      "pt-PT": "Sinhala; Sinhalese",
      "ro-RO": "Sinhala; Sinhalese",
      "ja-JP": "シンハラ語",
      "zh-Hans-CN": "僧伽罗语",
      "nl-NL": "Sinhala; Sinhalese",
      "es-ES": "Sinhala; Sinhalese",
      "sv-SE": "Sinhala; Sinhalese",
      "ru-RU": "Сингальский; Сингальский",
      "hu-HU": "Sinhala; Sinhalese",
    },
  },
  {
    code: "sk",
    label: {
      "en-US": "Slovak",
      "de-DE": "Slowakisch",
      "pt-BR": "Eslovaco",
      "fr-FR": "Slovaque",
      "zh-Hant-TW": "斯洛伐克語",
      "pt-PT": "Slovak",
      "ro-RO": "Slovacă",
      "ja-JP": "スロバキア語",
      "zh-Hans-CN": "斯洛伐克语",
      "nl-NL": "Slovak",
      "es-ES": "Eslovaco",
      "sv-SE": "Slovak",
      "ru-RU": "Словацкий",
      "hu-HU": "Slovak",
    },
  },
  {
    code: "sl",
    label: {
      "en-US": "Slovenian",
      "de-DE": "Slowenisch",
      "pt-BR": "Esloveno",
      "fr-FR": "Slovène",
      "zh-Hant-TW": "斯洛維尼亞語",
      "pt-PT": "Esloveno",
      "ro-RO": "Slovină",
      "ja-JP": "スロベニア語",
      "zh-Hans-CN": "斯洛文尼亚语",
      "nl-NL": "Slovinščina",
      "es-ES": "Esloveno",
      "sv-SE": "Slovenščina",
      "ru-RU": "Словенский",
      "hu-HU": "Slovenian",
    },
  },
  {
    code: "sm",
    label: {
      "en-US": "Samoan",
      "de-DE": "Samoan",
      "pt-BR": "Samoano",
      "fr-FR": "Samoan",
      "zh-Hant-TW": "薩摩亞語",
      "pt-PT": "Samoan",
      "ro-RO": "Samoan",
      "ja-JP": "サモア語",
      "zh-Hans-CN": "萨摩亚语",
      "nl-NL": "Samoaans",
      "es-ES": "Samoa",
      "sv-SE": "Samoan",
      "ru-RU": "Самоанский",
      "hu-HU": "Samoan",
    },
  },
  {
    code: "sn",
    label: {
      "en-US": "Shona",
      "de-DE": "Shona",
      "pt-BR": "Shona",
      "fr-FR": "Shona",
      "zh-Hant-TW": "修納語",
      "pt-PT": "Shona",
      "ro-RO": "Shona",
      "ja-JP": "ショナ語",
      "zh-Hans-CN": "修纳语",
      "nl-NL": "Shona",
      "es-ES": "Shona",
      "sv-SE": "Shona",
      "ru-RU": "Шона",
      "hu-HU": "Shona",
    },
  },
  {
    code: "so",
    label: {
      "en-US": "Somali",
      "de-DE": "Somali",
      "pt-BR": "Somali",
      "fr-FR": "Somali",
      "zh-Hant-TW": "索馬里語",
      "pt-PT": "Somali",
      "ro-RO": "Somali",
      "ja-JP": "ソマリ語",
      "zh-Hans-CN": "索马里语",
      "nl-NL": "Somali",
      "es-ES": "Somali",
      "sv-SE": "Somali",
      "ru-RU": "Сомали",
      "hu-HU": "Somali",
    },
  },
  {
    code: "sq",
    label: {
      "en-US": "Albanian",
      "de-DE": "Albanisch",
      "pt-BR": "Albânico",
      "fr-FR": "Albanais",
      "zh-Hant-TW": "阿爾巴尼亞語",
      "pt-PT": "Albanian",
      "ro-RO": "Albaneză",
      "ja-JP": "アルバニア語",
      "zh-Hans-CN": "阿尔巴尼亚语",
      "nl-NL": "Albanees",
      "es-ES": "Albanian",
      "sv-SE": "Albanian",
      "ru-RU": "Албанский",
      "hu-HU": "Albanian",
    },
  },
  {
    code: "sr",
    label: {
      "en-US": "Serbian",
      "de-DE": "Serbisch",
      "pt-BR": "Sérvio",
      "fr-FR": "Serbe",
      "zh-Hant-TW": "塞爾維亞語",
      "pt-PT": "Serbian",
      "ro-RO": "Serbian",
      "ja-JP": "セルビア語",
      "zh-Hans-CN": "塞尔维亚语",
      "nl-NL": "Servisch",
      "es-ES": "Serbio",
      "sv-SE": "Serbian",
      "ru-RU": "Сербский",
      "hu-HU": "Serbian",
    },
  },
  {
    code: "ss",
    label: {
      "en-US": "Swati",
      "de-DE": "Swati",
      "pt-BR": "Swati",
      "fr-FR": "Swati",
      "zh-Hant-TW": "史瓦濟語",
      "pt-PT": "Swati",
      "ro-RO": "Swati",
      "ja-JP": "スワティ語",
      "zh-Hans-CN": "斯瓦蒂语",
      "nl-NL": "Swati",
      "es-ES": "Swati",
      "sv-SE": "Swati",
      "ru-RU": "Свази",
      "hu-HU": "Swati",
    },
  },
  {
    code: "st",
    label: {
      "en-US": "Sotho, Southern",
      "de-DE": "Sotho, Süd",
      "pt-BR": "Sotho, Sul",
      "fr-FR": "Sotho, Sud",
      "zh-Hant-TW": "南索托語",
      "pt-PT": "Sotho, Sul",
      "ro-RO": "Sotho, Sud",
      "ja-JP": "ソト語",
      "zh-Hans-CN": "南索托语",
      "nl-NL": "Sotho, Zuid",
      "es-ES": "Sotho, Sul",
      "sv-SE": "Sotho, Sul",
      "ru-RU": "Сотто, Юг",
      "hu-HU": "Sotho, Southern",
    },
  },
  {
    code: "su",
    label: {
      "en-US": "Sundanese",
      "de-DE": "Sundanesisch",
      "pt-BR": "Sundanês",
      "fr-FR": "Sundanais",
      "zh-Hant-TW": "巽他語",
      "pt-PT": "Sundanese",
      "ro-RO": "Sundanese",
      "ja-JP": "スンダ語",
      "zh-Hans-CN": "巽他语",
      "nl-NL": "Sundanees",
      "es-ES": "Sundanese",
      "sv-SE": "Sundanese",
      "ru-RU": "Сунданский",
      "hu-HU": "Sundanese",
    },
  },
  {
    code: "sv",
    label: {
      "en-US": "Swedish",
      "de-DE": "Schwedisch",
      "pt-BR": "Sueco",
      "fr-FR": "Suédois",
      "zh-Hant-TW": "瑞典語",
      "pt-PT": "Sueco",
      "ro-RO": "Suedeză",
      "ja-JP": "スウェーデン語",
      "zh-Hans-CN": "瑞典语",
      "nl-NL": "Zweeds",
      "es-ES": "Sueco",
      "sv-SE": "Svenska",
      "ru-RU": "Шведский",
      "hu-HU": "Swedish",
    },
  },
  {
    code: "sw",
    label: {
      "en-US": "Swahili",
      "de-DE": "Swahili",
      "pt-BR": "Swahili",
      "fr-FR": "Swahili",
      "zh-Hant-TW": "史瓦希里語",
      "pt-PT": "Swahili",
      "ro-RO": "Swahili",
      "ja-JP": "スワヒリ語",
      "zh-Hans-CN": "斯瓦希里语",
      "nl-NL": "Swahili",
      "es-ES": "Swahili",
      "sv-SE": "Swahili",
      "ru-RU": "Суахили",
      "hu-HU": "Swahili",
    },
  },
  {
    code: "ta",
    label: {
      "en-US": "Tamil",
      "de-DE": "Tamil",
      "pt-BR": "Tâmil",
      "fr-FR": "Tamoul",
      "zh-Hant-TW": "泰米爾語",
      "pt-PT": "Tamil",
      "ro-RO": "Tamil",
      "ja-JP": "タミル語",
      "zh-Hans-CN": "泰米尔语",
      "nl-NL": "Tamil",
      "es-ES": "Tamil",
      "sv-SE": "Tamil",
      "ru-RU": "Тамильский",
      "hu-HU": "Tamil",
    },
  },
  {
    code: "te",
    label: {
      "en-US": "Telugu",
      "de-DE": "Telugu",
      "pt-BR": "Telugu",
      "fr-FR": "Telugu",
      "zh-Hant-TW": "泰盧固語",
      "pt-PT": "Telugu",
      "ro-RO": "Telugu",
      "ja-JP": "テルグ語",
      "zh-Hans-CN": "泰卢固语",
      "nl-NL": "Telugu",
      "es-ES": "Telugu",
      "sv-SE": "Telugu",
      "ru-RU": "Телугу",
      "hu-HU": "Telugu",
    },
  },
  {
    code: "tg",
    label: {
      "en-US": "Tajik",
      "de-DE": "Tadschikisch",
      "pt-BR": "Tajique",
      "fr-FR": "Tadjik",
      "zh-Hant-TW": "塔吉克語",
      "pt-PT": "Tadjik",
      "ro-RO": "Tadjik",
      "ja-JP": "タジク語",
      "zh-Hans-CN": "塔吉克语",
      "nl-NL": "Tadjik",
      "es-ES": "Tadjik",
      "sv-SE": "Tadjik",
      "ru-RU": "Таджикский",
      "hu-HU": "Tajik",
    },
  },
  {
    code: "th",
    label: {
      "en-US": "Thai",
      "de-DE": "Thai",
      "pt-BR": "Tailandês",
      "fr-FR": "Thaïlandais",
      "zh-Hant-TW": "泰語",
      "pt-PT": "Tailandês",
      "ro-RO": "Thai",
      "ja-JP": "タイ語",
      "zh-Hans-CN": "泰语",
      "nl-NL": "Thai",
      "es-ES": "Tailandés",
      "sv-SE": "Thai",
      "ru-RU": "Тайский",
      "hu-HU": "Thai",
    },
  },
  {
    code: "ti",
    label: {
      "en-US": "Tigrinya",
      "de-DE": "Tigrinya",
      "pt-BR": "Tigrinya",
      "fr-FR": "Tigrinya",
      "zh-Hant-TW": "提格利尼亞語",
      "pt-PT": "Tigrinya",
      "ro-RO": "Tigrinya",
      "ja-JP": "ティグリニャ語",
      "zh-Hans-CN": "提格利尼亚语",
      "nl-NL": "Tigrinya",
      "es-ES": "Tigrinya",
      "sv-SE": "Tigrinya",
      "ru-RU": "Тигринья",
      "hu-HU": "Tigrinya",
    },
  },
  {
    code: "tk",
    label: {
      "en-US": "Turkmen",
      "de-DE": "Turkmenisch",
      "pt-BR": "Turcomano",
      "fr-FR": "Turkmène",
      "zh-Hant-TW": "土庫曼語",
      "pt-PT": "Turkmène",
      "ro-RO": "Turcoman",
      "ja-JP": "トルクメン語",
      "zh-Hans-CN": "土库曼语",
      "nl-NL": "Turkmen",
      "es-ES": "Turcomano",
      "sv-SE": "Turkmen",
      "ru-RU": "Туркменский",
      "hu-HU": "Turkmen",
    },
  },
  {
    code: "tl",
    label: {
      "en-US": "Tagalog",
      "de-DE": "Tagalog",
      "pt-BR": "Tagalo",
      "fr-FR": "Tagalog",
      "zh-Hant-TW": "他加祿語",
      "pt-PT": "Tagalo",
      "ro-RO": "Tagalog",
      "ja-JP": "タガログ語",
      "zh-Hans-CN": "他加禄语",
      "nl-NL": "Tagalog",
      "es-ES": "Tagalo",
      "sv-SE": "Tagalog",
      "ru-RU": "Тагалог",
      "hu-HU": "Tagalog",
    },
  },
  {
    code: "tn",
    label: {
      "en-US": "Tswana",
      "de-DE": "Tswana",
      "pt-BR": "Tswana",
      "fr-FR": "Tswana",
      "zh-Hant-TW": "茨瓦納語",
      "pt-PT": "Tswana",
      "ro-RO": "Tswana",
      "ja-JP": "ツワナ語",
      "zh-Hans-CN": "茨瓦纳语",
      "nl-NL": "Tswana",
      "es-ES": "Tswana",
      "sv-SE": "Tswana",
      "ru-RU": "Тсвана",
      "hu-HU": "Tswana",
    },
  },
  {
    code: "to",
    label: {
      "en-US": "Tonga (Tonga Islands)",
      "de-DE": "Tonga (Tonga-Inseln)",
      "pt-BR": "Tonga (Ilhas Tonga)",
      "fr-FR": "Tonga (Îles Tonga)",
      "zh-Hant-TW": "東加語",
      "pt-PT": "Tonga (Ilhas Tonga)",
      "ro-RO": "Tonga (Tonga-Inseln)",
      "ja-JP": "トンガ語",
      "zh-Hans-CN": "东加语",
      "nl-NL": "Tonga (Tonga-Inseln)",
      "es-ES": "Tonga (Tonga-Inseln)",
      "sv-SE": "Tonga (Tonga-Inseln)",
      "ru-RU": "Тонга",
      "hu-HU": "Tonga (Tonga Islands)",
    },
  },
  {
    code: "tr",
    label: {
      "en-US": "Turkish",
      "de-DE": "Türkisch",
      "pt-BR": "Turco",
      "fr-FR": "Turc",
      "zh-Hant-TW": "土耳其語",
      "pt-PT": "Turco",
      "ro-RO": "Türkçe",
      "ja-JP": "トルコ語",
      "zh-Hans-CN": "土耳其语",
      "nl-NL": "Türkçe",
      "es-ES": "Turco",
      "sv-SE": "Türkçe",
      "ru-RU": "Турецкий",
      "hu-HU": "Turkish",
    },
  },
  {
    code: "ts",
    label: {
      "en-US": "Tsonga",
      "de-DE": "Tsonga",
      "pt-BR": "Tsonga",
      "fr-FR": "Tsonga",
      "zh-Hant-TW": "聰加語",
      "pt-PT": "Tsonga",
      "ro-RO": "Tsonga",
      "ja-JP": "ツォンガ語",
      "zh-Hans-CN": "聪加语",
      "nl-NL": "Tsonga",
      "es-ES": "Tsonga",
      "sv-SE": "Tsonga",
      "ru-RU": "Цонга",
      "hu-HU": "Tsonga",
    },
  },
  {
    code: "tt",
    label: {
      "en-US": "Tatar",
      "de-DE": "Tatarisch",
      "pt-BR": "Tatar",
      "fr-FR": "Tatar",
      "zh-Hant-TW": "韃靼語",
      "pt-PT": "Tatar",
      "ro-RO": "Tatar",
      "ja-JP": "タタール語",
      "zh-Hans-CN": "鞑靼语",
      "nl-NL": "Tatar",
      "es-ES": "Tatar",
      "sv-SE": "Tatar",
      "ru-RU": "Татарский",
      "hu-HU": "Tatar",
    },
  },
  {
    code: "tw",
    label: {
      "en-US": "Twi",
      "de-DE": "Twi",
      "pt-BR": "Twi",
      "fr-FR": "Twi",
      "zh-Hant-TW": "特威語",
      "pt-PT": "Twi",
      "ro-RO": "Twi",
      "ja-JP": "ツワ語",
      "zh-Hans-CN": "特威语",
      "nl-NL": "Twi",
      "es-ES": "Twi",
      "sv-SE": "Twi",
      "ru-RU": "Тви",
      "hu-HU": "Twi",
    },
  },
  {
    code: "ty",
    label: {
      "en-US": "Tahitian",
      "de-DE": "Tahitisch",
      "pt-BR": "Tahitiano",
      "fr-FR": "Tahitien",
      "zh-Hant-TW": "大溪地語",
      "pt-PT": "Tahitian",
      "ro-RO": "Tahitian",
      "ja-JP": "タヒチ語",
      "zh-Hans-CN": "大溪地语",
      "nl-NL": "Tahitian",
      "es-ES": "Tahitian",
      "sv-SE": "Tahitian",
      "ru-RU": "Таити",
      "hu-HU": "Tahitian",
    },
  },
  {
    code: "ug",
    label: {
      "en-US": "Uighur; Uyghur",
      "de-DE": "Uighur; Uyghur",
      "pt-BR": "Uigur; Uigur",
      "fr-FR": "Ouïghour; Ouïghour",
      "zh-Hant-TW": "維吾爾語",
      "pt-PT": "Uighur; Uyghur",
      "ro-RO": "Uighur; Uyghur",
      "ja-JP": "ウイグル語",
      "zh-Hans-CN": "维吾尔语",
      "nl-NL": "Uighur; Uyghur",
      "es-ES": "Uigur; Uigur",
      "sv-SE": "Uigur; Uigur",
      "ru-RU": "Уйгур; Уйгур",
      "hu-HU": "Uighur; Uyghur",
    },
  },
  {
    code: "uk",
    label: {
      "en-US": "Ukrainian",
      "de-DE": "Ukrainisch",
      "pt-BR": "Ucraniano",
      "fr-FR": "Ukrainien",
      "zh-Hant-TW": "烏克蘭語",
      "pt-PT": "Ucraniano",
      "ro-RO": "Ucrainian",
      "ja-JP": "ウクライナ語",
      "zh-Hans-CN": "乌克兰语",
      "nl-NL": "Ukrainisch",
      "es-ES": "Ucraniano",
      "sv-SE": "Ucraniano",
      "ru-RU": "Украинский",
      "hu-HU": "Ukrainian",
    },
  },
  {
    code: "ur",
    label: {
      "en-US": "Urdu",
      "de-DE": "Urdu",
      "pt-BR": "Urdu",
      "fr-FR": "Urdu",
      "zh-Hant-TW": "烏爾都語",
      "pt-PT": "Urdu",
      "ro-RO": "Urdu",
      "ja-JP": "ウルドゥー語",
      "zh-Hans-CN": "乌尔都语",
      "nl-NL": "Urdu",
      "es-ES": "Urdu",
      "sv-SE": "Urdu",
      "ru-RU": "Урду",
      "hu-HU": "Urdu",
    },
  },
  {
    code: "uz",
    label: {
      "en-US": "Uzbek",
      "de-DE": "Usbekisch",
      "pt-BR": "Usbeque",
      "fr-FR": "Ouzbek",
      "zh-Hant-TW": "烏茲別克語",
      "pt-PT": "Uzbek",
      "ro-RO": "Uzbek",
      "ja-JP": "ウズベク語",
      "zh-Hans-CN": "乌兹别克语",
      "nl-NL": "Usbekisch",
      "es-ES": "Uzbek",
      "sv-SE": "Uzbek",
      "ru-RU": "Узбекский",
      "hu-HU": "Uzbek",
    },
  },
  {
    code: "ve",
    label: {
      "en-US": "Venda",
      "de-DE": "Venda",
      "pt-BR": "Venda",
      "fr-FR": "Venda",
      "zh-Hant-TW": "文達語",
      "pt-PT": "Venda",
      "ro-RO": "Venda",
      "ja-JP": "ヴェンダ語",
      "zh-Hans-CN": "文达语",
      "nl-NL": "Venda",
      "es-ES": "Venda",
      "sv-SE": "Venda",
      "ru-RU": "Венда",
      "hu-HU": "Venda",
    },
  },
  {
    code: "vi",
    label: {
      "en-US": "Vietnamese",
      "de-DE": "Vietnamesisch",
      "pt-BR": "Vietnamita",
      "fr-FR": "Vietnamien",
      "zh-Hant-TW": "越南語",
      "pt-PT": "Vietnamita",
      "ro-RO": "Vietnamese",
      "ja-JP": "ベトナム語",
      "zh-Hans-CN": "越南语",
      "nl-NL": "Vietnamesisch",
      "es-ES": "Vietnamita",
      "sv-SE": "Vietnamesiska",
      "ru-RU": "Вьетнамский",
      "hu-HU": "Vietnamese",
    },
  },
  {
    code: "vo",
    label: {
      "en-US": "Volapük",
      "de-DE": "Volapük",
      "pt-BR": "Volapük",
      "fr-FR": "Volapük",
      "zh-Hant-TW": "沃拉普克語",
      "pt-PT": "Volapük",
      "ro-RO": "Volapük",
      "ja-JP": "ヴォラプキ語",
      "zh-Hans-CN": "沃拉普克语",
      "nl-NL": "Volapük",
      "es-ES": "Volapük",
      "sv-SE": "Volapük",
      "ru-RU": "Волапюк",
      "hu-HU": "Volapük",
    },
  },
  {
    code: "wa",
    label: {
      "en-US": "Walloon",
      "de-DE": "Wallonisch",
      "pt-BR": "Valão",
      "fr-FR": "Valon",
      "zh-Hant-TW": "瓦隆語",
      "pt-PT": "Valão",
      "ro-RO": "Valão",
      "ja-JP": "ワロン語",
      "zh-Hans-CN": "瓦隆语",
      "nl-NL": "Wallonisch",
      "es-ES": "Valón",
      "sv-SE": "Wallonisch",
      "ru-RU": "Валлонский",
      "hu-HU": "Walloon",
    },
  },
  {
    code: "wo",
    label: {
      "en-US": "Wolof",
      "de-DE": "Wolof",
      "pt-BR": "Wolof",
      "fr-FR": "Wolof",
      "zh-Hant-TW": "沃洛夫語",
      "pt-PT": "Wolof",
      "ro-RO": "Wolof",
      "ja-JP": "ウォロフ語",
      "zh-Hans-CN": "沃洛夫语",
      "nl-NL": "Wolof",
      "es-ES": "Wolof",
      "sv-SE": "Wolof",
      "ru-RU": "Волуф",
      "hu-HU": "Wolof",
    },
  },
  {
    code: "xh",
    label: {
      "en-US": "Xhosa",
      "de-DE": "Xhosa",
      "pt-BR": "Xhosa",
      "fr-FR": "Xhosa",
      "zh-Hant-TW": "科薩語",
      "pt-PT": "Xhosa",
      "ro-RO": "Xhosa",
      "ja-JP": "コサ語",
      "zh-Hans-CN": "科萨语",
      "nl-NL": "Xhosa",
      "es-ES": "Xhosa",
      "sv-SE": "Xhosa",
      "ru-RU": "Коса",
      "hu-HU": "Xhosa",
    },
  },
  {
    code: "yi",
    label: {
      "en-US": "Yiddish",
      "de-DE": "Jiddisch",
      "pt-BR": "Iídiche",
      "fr-FR": "Yiddish",
      "zh-Hant-TW": "意第緒語",
      "pt-PT": "Yiddish",
      "ro-RO": "Yiddish",
      "ja-JP": "イディッシュ語",
      "zh-Hans-CN": "意第绪语",
      "nl-NL": "Jiddisch",
      "es-ES": "Yiddish",
      "sv-SE": "Jiddisch",
      "ru-RU": "Идиш",
      "hu-HU": "Yiddish",
    },
  },
  {
    code: "yo",
    label: {
      "en-US": "Yoruba",
      "de-DE": "Yoruba",
      "pt-BR": "Iorubá",
      "fr-FR": "Yoruba",
      "zh-Hant-TW": "約魯巴語",
      "pt-PT": "Yoruba",
      "ro-RO": "Yoruba",
      "ja-JP": "ヨルバ語",
      "zh-Hans-CN": "约鲁巴语",
      "nl-NL": "Yoruba",
      "es-ES": "Yoruba",
      "sv-SE": "Yoruba",
      "ru-RU": "Йоруба",
      "hu-HU": "Yoruba",
    },
  },
  {
    code: "za",
    label: {
      "en-US": "Zhuang; Chuang",
      "de-DE": "Zhuang; Chuang",
      "pt-BR": "Zhuang; Chuang",
      "fr-FR": "Zhuang; Chuang",
      "zh-Hant-TW": "壯語",
      "pt-PT": "Zhuang; Chuang",
      "ro-RO": "Zhuang; Chuang",
      "ja-JP": "壮語",
      "zh-Hans-CN": "壮语",
      "nl-NL": "Zhuang; Chuang",
      "es-ES": "Zhuang; Chuang",
      "sv-SE": "Zhuang; Chuang",
      "ru-RU": "Чжуань; Чжуань",
      "hu-HU": "Zhuang; Chuang",
    },
  },
  {
    code: "zh-Hans",
    label: {
      "en-US": "Chinese (Simplified)",
      "de-DE": "Chinesisch (Vereinfacht)",
      "pt-BR": "Chinês (Simplificado)",
      "fr-FR": "Chinois (Simplifié)",
      "zh-Hant-TW": "簡體中文",
      "pt-PT": "Chinês (Simplificado)",
      "ro-RO": "Chinês (Simplificado)",
      "ja-JP": "中国語（簡体字）",
      "zh-Hans-CN": "简体中文",
      "nl-NL": "Chinees (Vereenvoudigd)",
      "es-ES": "Chino (Simplificado)",
      "sv-SE": "Kinesiska (förenklad)",
      "ru-RU": "Китайский (упрощенный)",
      "hu-HU": "Chinese (Simplified)",
    },
  },
  {
    code: "zh-Hant",
    label: {
      "en-US": "Chinese (Traditional)",
      "de-DE": "Chinesisch (Traditionell)",
      "pt-BR": "Chinês (Tradicional)",
      "fr-FR": "Chinois (Traditionnel)",
      "zh-Hant-TW": "繁體中文",
      "pt-PT": "Chinês (Tradicional)",
      "ro-RO": "Chinês (Tradicional)",
      "ja-JP": "中国語（繁体字）",
      "zh-Hans-CN": "繁体中文",
      "nl-NL": "Chinees (Traditioneel)",
      "es-ES": "Chino (Tradicional)",
      "sv-SE": "Kinesiska (traditionell)",
      "ru-RU": "Китайский (традиционный)",
      "hu-HU": "Chinese (Traditional)",
    },
  },
  {
    code: "zh-CN",
    label: {
      "en-US": "Chinese (China)",
      "de-DE": "Chinesisch (China)",
      "pt-BR": "Chinês (China)",
      "fr-FR": "Chinois (Chine)",
      "zh-Hant-TW": "中文（中國）",
      "pt-PT": "Chinês (China)",
      "ro-RO": "Chineză (China)",
      "ja-JP": "中国語（中国）",
      "zh-Hans-CN": "中文（中国）",
      "nl-NL": "Chinees (China)",
      "es-ES": "Chino (China)",
      "sv-SE": "Kinesiska (Kina)",
      "ru-RU": "Китайский (Китай)",
      "hu-HU": "Chinese (China)",
    },
  },
  {
    code: "zh-TW",
    label: {
      "en-US": "Chinese (Taiwan)",
      "de-DE": "Chinesisch (Taiwan)",
      "pt-BR": "Chinês (Taiwan)",
      "fr-FR": "Chinois (Taïwan)",
      "zh-Hant-TW": "中文（台灣）",
      "pt-PT": "Chinês (Taiwan)",
      "ro-RO": "Chineză (Taiwan)",
      "ja-JP": "中国語（台湾）",
      "zh-Hans-CN": "中文（台湾）",
      "nl-NL": "Chinees (Taiwan)",
      "es-ES": "Chino (Taiwán)",
      "sv-SE": "Kinesiska (Taiwan)",
      "ru-RU": "Китайский (Тайвань)",
      "hu-HU": "Chinese (Taiwan)",
    },
  },
  {
    code: "zh-HK",
    label: {
      "en-US": "Chinese (Hong Kong)",
      "de-DE": "Chinesisch (Hongkong)",
      "pt-BR": "Chinês (Hong Kong)",
      "fr-FR": "Chinois (Hong Kong)",
      "zh-Hant-TW": "中文（香港）",
      "pt-PT": "Chinês (Hong Kong)",
      "ro-RO": "Chineză (Hong Kong)",
      "ja-JP": "中国語（香港）",
      "zh-Hans-CN": "中文（香港）",
      "nl-NL": "Chinees (Hongkong)",
      "es-ES": "Chino (Hong Kong)",
      "sv-SE": "Kinesiska (Hongkong)",
      "ru-RU": "Китайский (Гонконг)",
      "hu-HU": "Chinese (Hong Kong)",
    },
  },
  {
    code: "zu",
    label: {
      "en-US": "Zulu",
      "de-DE": "Zulu",
      "pt-BR": "Zulu",
      "fr-FR": "Zulu",
      "zh-Hant-TW": "祖魯語",
      "pt-PT": "Zulu",
      "ro-RO": "Zulu",
      "ja-JP": "ズールー語",
      "zh-Hans-CN": "祖鲁语",
      "nl-NL": "Zulu",
      "es-ES": "Zulu",
      "sv-SE": "Zulu",
      "ru-RU": "Зулу",
      "hu-HU": "Zulu",
    },
  },
] as const satisfies readonly TIso639Language[];

/**
 * Union of every ISO 639 language code Formbricks supports.
 * Derived automatically from the `iso639Languages` array — stays in sync
 * without any manual maintenance.
 */
export type Iso639Code = (typeof iso639Languages)[number]["code"];

export const getLanguageLabel = (languageCode: string, locale: string): string | undefined => {
  const language = iso639Languages.find((lang) => lang.code === languageCode);
  // Type assertion to tell TypeScript that we know the structure of label
  return language?.label[locale as keyof typeof language.label];
};
